import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import commonStore from "./stores/commonStore";
import authStore from "./stores/authStore";
import userStore from "./stores/userStore";
import CacheHelper from "./helper/cache";
import { API } from "aws-amplify";
import { rosterQueryString, rosterFilterQueryString } from "./helper/actRosterQuery";

import templateStore from "./stores/templateStore";

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = process.env.REACT_APP_MAIN_SERVICE_URL;

const encode = encodeURIComponent;

let refreshTokenPromise = null;

const tryRefreshToken = async () => {
    if (!refreshTokenPromise) {
        refreshTokenPromise = authStore.refreshToken()
            .then(result => {
                refreshTokenPromise = null;
                return result;
            })
            .catch(err => {
                refreshTokenPromise = null;
                throw err;
            });
    }
    return refreshTokenPromise;
};

const handleErrors = err => {
    if (err && err.response && err.response.status === 403) {
        if (templateStore.history?.location?.pathname !== "/unauthorized") {
            templateStore.redirectTo("/unauthorized");
        }
    }
    return err;
};

const superagentWithRetry = async (buildRequest) => {
    try {
        const res = await buildRequest().use(tokenPlugin).end(handleErrors);
        return res;
    } catch (err) {
        if (err && err.response && err.response.status === 401) {
            try {
                await tryRefreshToken();
                const retryRes = await buildRequest().use(tokenPlugin).end(handleErrors);
                return retryRes;
            } catch (retryErr) {
                return { body: null, text: "" };
            }
        }
        throw err;
    }
};

const responseBody = res => res.body;
const responseBodyAmplify = res => res.response;
const responsePlainAmplify = res => res;
const responseText = res => res.text;

const tokenPlugin = req => {
    if (commonStore.token) {
        req.set("authorization", `Bearer ${commonStore.token}`);
    }
    if (commonStore.impersonateUserId) {
        req.set("X-Impersonate-User-Id", commonStore.impersonateUserId);
    }
}

const urlEncoded = req => {
    req.set("Content-Type", `application/x-www-form-urlencoded`);
}

const customRequest = (body) => {
    const headers = {};
    if (commonStore.token) {
        headers["Authorization"] = `Bearer ${commonStore.token}`;
    }
    if (commonStore.impersonateUserId) {
        headers["X-Impersonate-User-Id"] = commonStore.impersonateUserId;
    }
    if (body) {
        return { headers, body };
    }
    return { headers };
};

const customRequestLocal = (body) => {
    const headers = {
        "Access-Control-Allow-Origin": "*",
    };
    if (commonStore.token) {
        headers["Authorization"] = `Bearer ${commonStore.token}`;
    }
    return { headers, body };
};

const amplifyRequest = async (method, api, url, config, propagateAuthError = false) => {
    try {
        return await API[method](api, url, config);
    } catch (error) {
        const status = error?.response?.statusCode || error?.response?.status;
        const is401 = status === 401 || (error?.message && error.message.includes("401"));
        if (is401) {
            try {
                await tryRefreshToken();
                const retryConfig = { ...config, ...customRequest(config?.body) };
                return await API[method](api, url, retryConfig);
            } catch (retryErr) {
                if (propagateAuthError) throw retryErr;
                return { response: null };
            }
        } else if (status === 403) {
            if (templateStore.history?.location?.pathname !== "/unauthorized") {
                templateStore.redirectTo("/unauthorized");
            }
        }
        throw error;
    }
};

var localheaders = function() {
    return ({
      "Access-Control-Allow-Origin": "*",
    });
  };

const requests = {
    del: async url => {
        return superagentWithRetry(() => superagent.del(`${API_ROOT}${url}`))
            .then(responseBody);
    },
    delAmplify: async (api, url) => {
        return await amplifyRequest('del', api, `${url}`, customRequest())
            .then(responseBodyAmplify);
    },
    delWithBodyAmplify: async (api, url, body) => {
        return await amplifyRequest('del', api, `${url}`, customRequest(body))
            .then(responseBodyAmplify);
    },
    get: async url => {
        return superagentWithRetry(() => superagent.get(`${API_ROOT}${url}`))
            .then(responseBody);
    },
    myobPost: async (body) => {
        // authStore.refreshToken();
        return superagent
            .post(`https://secure.myob.com/oauth2/v1/authorize`, body)
            // .use(urlEncoded)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .end(handleErrors)
            .then(responseBody);
    },
   
    getLocal: async url => {
        // authStore.refreshToken();
        return superagent
            .get(`http://localhost:3000${url}`)
            .type("json") // DOH. Why we do this????
            .then(responseBody);
    },
    getAmplify: async (api, url) => {
        return await amplifyRequest('get', api, `${url}`, customRequest())
            .then(responseBodyAmplify);
    },
    getPlainAmplify: async (api, url, queryStringParameters = null) => {
        const config = customRequest();
        if (queryStringParameters) {
            config.queryStringParameters = queryStringParameters;
        }
        return await amplifyRequest('get', api, `${url}`, config)
            .then(responsePlainAmplify);
    },
    getFile: async url => {
        return superagentWithRetry(() => superagent.get(`${API_ROOT}${url}`))
            .then(responseText);
    },
    put: async (url, body) => {
        return superagentWithRetry(() => superagent.put(`${API_ROOT}${url}`, body))
            .then(responseBody);
    },
    putAmplify: async (api, url, body) => {
        return await amplifyRequest('put', api, url, customRequest(body))
            .then(responseBodyAmplify);
    },
    patch: async (url, body) => {
        return superagentWithRetry(() => superagent.patch(`${API_ROOT}${url}`, body))
            .then(responseBody);
    },
    patchAmplify: async (api, url, body) => {
        return await amplifyRequest('patch', api, url, customRequest(body))
            .then(responseBodyAmplify);
    },
    publicPost: async (url, body) => {
        return superagent
            .post(`${API_ROOT}${url}`, body)
            .then(responseBody);
    },
    publicGetAmplify: async (api, url) => {
        return await API
            .get(api, `${url}`, { headers: {} })
            .then(responseBodyAmplify);
    },
    publicPostAmplify: async (api, url, body) => {
        return await API
            .post(api, url, { headers: {}, body })
            .then(responseBodyAmplify);
    },
    post: async (url, body) => {
        return superagentWithRetry(() => superagent.post(`${API_ROOT}${url}`, body))
            .then(responseBody);
    },
    postLocal: async (url, body) => {
        // authStore.refreshToken();
        return superagent
            .post(`http://localhost:3000${url}`, body)
            .type("json") // DOH. Why we do this????
            .end(handleErrors)
            .then(responseBody);
    },
    putLocal: async (be, url, body) => {
        // authStore.refreshToken();
        return superagent
            .put(`http://localhost:3000${url}`, customRequestLocal(body))
            .type("json") // DOH. Why we do this????
            .end(handleErrors)
            .then(responseBody);
    },
    postAmplify: async (api, url, body) => {
        return await amplifyRequest('post', api, url, customRequest(body))
            .then(responseBodyAmplify);
    },
    postAmplifyStrict: async (api, url, body) => {
        return await amplifyRequest('post', api, url, customRequest(body), true)
            .then(responseBodyAmplify);
    },
    customUrlPost: async (url, body) => {
        return superagentWithRetry(() => superagent.post(`${url}`, body))
            .then(responseBody);
    },
    simplePostForSoundcloud: async (url, body) => {
        // we use post in this format to avoid the CORST prefligt request, which is currently blocked by soundcloud for unknown reason
        return superagent
            .post(`${url}`)
            .type("form")
            .send({ url: body.url })
            .send({ format: body.format })
            .then(responseBody);
    },
    upload: async (url, files) => {
        return superagentWithRetry(() => {
            var req = superagent.post(`${API_ROOT}${url}`);
            files.forEach(file => {
                req.attach("files", file);
            });
            return req;
        }).then(responseBody);
    },
    uploadSignature: (url, signature) => {
        return superagentWithRetry(() => {
            var req = superagent.post(`${API_ROOT}${url}`);
            req.attach("signature", signature, "signature.png");
            return req;
        }).then(responseBody);
    },
    googlePlace: async (key, placeId) => {
        return superagent
            .get(`https://places.googleapis.com/v1/places/${placeId}`)
            .set('Content-Type', 'application/json')
            .set('X-Goog-Api-Key', `${key}`)
            .set('X-Goog-FieldMask', 'id,displayName,photos')
            .end(handleErrors)
            .then(responseBody);
    },


    
};

const Auth = {
    handleSetAgent: (data) => requests.putAmplify("hotgiggity-be", `/profile/toggle/toggleActivateEditVenue`,data),
    current: () => requests.get("/user/me"),
    login: (email, password, source) => requests.publicPost("/user/login", { email: email, password: password, source: source }),
    register: (email, firstName, lastName, password, confirmPassword, type, token, source) =>
        requests.publicPostAmplify("hotgiggity-be", source ? `/user/register/${source}` : `/user/register`, {
            firstName: firstName,
            lastName: lastName,
            email: email,
            password: password,
            confirmPassword: confirmPassword,
            type: type,
            invitationToken: token
        }),
    reregister: (email, invitationCode) =>
        requests.publicPostAmplify("hotgiggity-be", `/user/reregister`, {
            email: email,
            invitationCode: invitationCode
        }),
    getDataMappingUserInit: invitationCode => requests.publicGetAmplify("hotgiggity-be", `/user/${invitationCode}/reregistration`),
    getUser: () => requests.getAmplify("hotgiggity-be", "/user"),
    save: user => requests.putAmplify("hotgiggity-be", "/user", user),
    changePassword: (password, newPassword, confirmPassword) =>
        requests.postAmplify("hotgiggity-be", "/user/changePassword", {
            currentPassword: password,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        }),
    forgotPassword: email => requests.publicPost("/user/reset", { email: email }),
    createNewPassword: (signature, newPassword, confirmPassword) =>
        requests.post("/user/createnewpassword", {
            password: signature,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        }),
    complete: () => requests.postAmplify("hotgiggity-be", "/user/complete"),
    updateIntegration: user => requests.put("/user/integration", user),
    confirmationToken: (email, firstName, lastName, token) =>
        requests.get(
            `/user/confirmationtoken?email=${encode(email)}&firstName=${encode(firstName)}&lastName=${encode(lastName)}&token=${encode(token)}`
        ),
    resendConfirmationToken: email => requests.get(`/user/resendConfirmationToken?email=${encode(email)}`),
    changeUserEmail: data => requests.postAmplify("hotgiggity-be", `/user/changeEmail`, data),
    resendLink: data => requests.postAmplify("hotgiggity-be", `/user/resend`, data),
    setUserFreeOrNotFree: data => requests.postAmplify("hotgiggity-be", `/user/set/freeornot`, data),
    setProPlan: data => requests.postAmplify("hotgiggity-be", `/user/set/isProPlan`, data)
    
};

const Tags = {
    getAll: () => requests.get("/tags")
};

const SuperAnnuationProvider = {
    getAll: () => requests.getAmplify("hotgiggity-be", "/super/provider/all"),
    getByABN: (abn) => requests.getAmplify("hotgiggity-be", `/super/provider/abn/${abn}`),
};

const limit = (count, p) => `limit=${count}&offset=${p ? p * count : 0}`;
const omitSlug = article => Object.assign({}, article, { slug: undefined });

const Articles = {
    all: (page, lim = 10) => requests.get(`/articles?${limit(lim, page)}`),
    byAuthor: (author, page, query) => requests.get(`/articles?author=${encode(author)}&${limit(5, page)}`),
    byTag: (tag, page, lim = 10) => requests.get(`/articles?tag=${encode(tag)}&${limit(lim, page)}`),
    del: slug => requests.del(`/articles/${slug}`),
    favorite: slug => requests.post(`/articles/${slug}/favorite`),
    favoritedBy: (author, page) => requests.get(`/articles?favorited=${encode(author)}&${limit(5, page)}`),
    feed: () => requests.get("/articles/feed?limit=10&offset=0"),
    get: slug => requests.get(`/articles/${slug}`),
    unfavorite: slug => requests.del(`/articles/${slug}/favorite`),
    update: article => requests.put(`/articles/${article.slug}`, { article: omitSlug(article) }),
    create: article => requests.post("/articles", { article })
};

const Comments = {
    create: (slug, comment) => requests.post(`/articles/${slug}/comments`, { comment }),
    delete: (slug, commentId) => requests.del(`/articles/${slug}/comments/${commentId}`),
    forArticle: slug => requests.get(`/articles/${slug}/comments`)
};


const MYOB = {
    connectMyob : (profileId, body) => requests.postAmplify("hotgiggity-be", `/myob/${profileId}/connect`,body),
    getListOfAccounts : (profileId) => requests.getAmplify("hotgiggity-be", `/myob/${profileId}/listaccounts`),
    mapAccounts: (profileId,body) => requests.putAmplify("hotgiggity-be", `/myob/${profileId}/mapaccounts`,body),
    getListMYOBMappedCustomers : (profileId) => requests.getAmplify("hotgiggity-be", `/myob/${profileId}/mappedcustomers`),
    getListMYOBMappedSuppliers : (profileId) => requests.getAmplify("hotgiggity-be", `/myob/${profileId}/mappedsuppliers`),
    getMYOBSuppliers : (profileId) => requests.getAmplify("hotgiggity-be", `/myob/${profileId}/contact/suppliers`),
    getMYOBCustomers : (profileId) => requests.getAmplify("hotgiggity-be", `/myob/${profileId}/contact/customers`),
    createMYOBSuppliers :(profileId, supplierID) => requests.postAmplify("hotgiggity-be", `/myob/${profileId}/contact/${supplierID}/suppliers`),
    createMYOBCustomers :(profileId, customerId) => requests.postAmplify("hotgiggity-be", `/myob/${profileId}/contact/${customerId}/customers`),
    mapExistingMYOBSupplier :(profileId, body) => requests.postAmplify("hotgiggity-be", `/myob/${profileId}/map/supplier`,body),
    mapExistingMYOBCustomer :(profileId, body) => requests.postAmplify("hotgiggity-be", `/myob/${profileId}/map/customer`,body),
    deleteContactMYOB :(id) => requests.postAmplify("hotgiggity-be", `/myob/contact/delete/${id}`),
    updateContactMYOB: (id,data) => requests.putAmplify("hotgiggity-be", `/myob/${id}/map/update`,data),
    integrateIncomingInvoice: (profileId,data) => requests.postAmplify("hotgiggity-be", `/myob/${profileId}/createBill`,data),
    integrateOutgoingInvoice: (profileId,data) => requests.postAmplify("hotgiggity-be", `/myob/${profileId}/createInvoice`,data),
    disconnect: (profileId) => requests.putAmplify("hotgiggity-be", `/myob/${profileId}/disconnect`),
    getInvoiceMYOBCustomerById : (profileId,invoiceId) => requests.getAmplify("hotgiggity-be", `/myobcustomers/${profileId}/invoice/${invoiceId}`),
    getMappedInvoiceMYOBCustomer : (profileId,invoiceId) => requests.getAmplify("hotgiggity-be", `/myobcustomers/${profileId}/mapped/invoice/${invoiceId}`),
    createInvoiceMYOBCustomer: (profileId,data) => requests.postAmplify("hotgiggity-be", `/myobcustomers/${profileId}`,data),
    createMappedInvoiceMYOBCustomer: (data) => requests.postAmplify("hotgiggity-be", `/myobcustomers/mapped/invoice`,data),
    updateInvoiceMYOBCustomer: (profileId,invoiceId,data) => requests.putAmplify("hotgiggity-be", `/myobcustomers/${profileId}/invoice/${invoiceId}`, data),
    updateMapInvoiceMYOBCustomer: (data) => requests.putAmplify("hotgiggity-be", `/myobcustomers/mapped/invoice`, data),
    deleteMapInvoiceMYOBCustomer: (data) => requests.putAmplify("hotgiggity-be", `/myobcustomers/mapped/delete`, data),
    getCompanyUriList: (profileId) => requests.getAmplify("hotgiggity-be", `/myob/listCompanies/${profileId}`),
    mapCompanyUri: (data) => requests.postAmplify("hotgiggity-be", `/myob/initialMap`,data),
}

const XeroLogs = {
    getXeroLogById: profileId => requests.getAmplify("hotgiggity-be", `/xero/error/logs/${profileId}`),
    markAsResolved: id => requests.putAmplify("hotgiggity-be", `/xero/error/logs/markresolve/${id}`),

  
}
const Profile = {
    saveTaxFileNumber: (data)  => requests.postAmplify("hotgiggity-be", `/profile/taxFileNumber`, data),
    getAgentVenueContact: (venueId, agentId) => requests.getAmplify("hotgiggity-be", `/profile/${venueId}/agentVenue/${agentId}`),
    getVenueMasterChecking: id => requests.getAmplify("hotgiggity-be", `/profile/venue/venuemasterchecking/${id}`),
    checkEmailValid: email => requests.getAmplify("hotgiggity-be", `/check/email/${email}`),
    toggleXeroMarkAsSent: id => requests.putAmplify("hotgiggity-be", `/profile/toggle/xeromarkassent/${id}`),
    getBackgroundImageById: id => requests.getAmplify("hotgiggity-be", `/profile/backgroundimage/${id}`),
    getAllImageById: id => requests.getAmplify("hotgiggity-be", `/profile/allimage/${id}`),
    getFullImages: profileId => requests.getAmplify("hotgiggity-be", `/profiles/${profileId}/images`),
    follow: username => requests.post(`/profiles/${username}/follow`),
    getByUserId: userId => requests.get(`/user/${userId}/profile`),
    loadActiveUsers: (limit, token) => requests.getAmplify("hotgiggity-be", "/user/active?limit=" + limit + "&token=" + token),
    searchActiveUsers: (value) => requests.getAmplify("hotgiggity-be", `/user/active/search/${value}`),
    loadLegacyUsers: (limit, page) => requests.getAmplify("hotgiggity-be", "/user/legacy?limit=" + limit + "&page=" + page),
    searchLegacyUsers: (value, limit, page) => requests.getAmplify("hotgiggity-be", "/user/legacy/search/" + value + "?limit=" + limit + "&page=" + page),
    loadProfiles: () => requests.getAmplify("hotgiggity-be", "/user/me/profile"),
    loadActs: userId => requests.getAmplify("hotgiggity-be", `/user/${userId}/acts`),
    // getByUserIdAndType: (userId, type) => requests.get(`/user/${hotgiggity-be}/profile/${type}`),
    getByUserIdAndType: (userId, type) => requests.getAmplify("hotgiggity-be", `/user/${userId}/profile/${type}`),
    unfollow: username => requests.del(`/profiles/${username}/follow`),
    getUserActListByProfileId: profileId => requests.getAmplify("hotgiggity-be", `/profile/act/list/${profileId}`),
    getUserActListSocialByProfileId: profileId => requests.getAmplify("hotgiggity-be", `/profile/act/list/social/${profileId}`),
    getUserTotalActListByProfileId: profileId => requests.getAmplify("hotgiggity-be", `/profile/act/list/${profileId}/total`),
    getAgentMyActs: profileId => requests.getAmplify("hotgiggity-be", `/profile/${profileId}/myActs`),
    getById: profileId => requests.getAmplify("hotgiggity-be", `/profile/detail/${profileId}`),
    getByIdSimple: profileId => requests.getAmplify("hotgiggity-be", `/profile/simple/${profileId}`),
    
    getProfileAct: () => requests.getAmplify("hotgiggity-be", `/getprofileact`),
    get: profileId => requests.getAmplify("hotgiggity-be", `/profile/${profileId}/data`),
    getPublicProfileByVanityUrl: vanityUrl => requests.publicGetAmplify("hotgiggity-be", `/profile/public/vanity/${vanityUrl}`),
    getPublicProfileById: id => requests.publicGetAmplify("hotgiggity-be", `/profile/public/id/${id}`),
    toggleXeroSyncPDF: id => requests.putAmplify("hotgiggity-be", `/profile/toggle/xerosyncpdf/${id}`),
    setCheckboxInvoice: id => requests.putAmplify("hotgiggity-be", `/profile/toggle/toggleCheckboxInvoice/${id}`),
    toggleXeroSettingApproved: id => requests.putAmplify("hotgiggity-be", `/profile/toggle/xeroapprovedsetting/${id}`),
    delete: profileId => requests.putAmplify("hotgiggity-be", `/profile/${profileId}`),

    createSoloAct: () => requests.postAmplify("hotgiggity-be", `/profile/act/solo`),

    searchMusician: name => requests.getAmplify("hotgiggity-be", "/profile/search/musician/" + name),
    searchConsultant: name => requests.getAmplify("hotgiggity-be", "/profile/search/consultant/" + name),
    searchProduction: name => requests.get("/profile/search/production/" + name),
    searchVenueProfile: name => requests.getAmplify("hotgiggity-be", `/profile/search/venue?query=${name}`),
    search: searchQuery => requests.getAmplify("hotgiggity-be", "/profile/search?" + searchQuery),
    searchAct: name => requests.getAmplify("hotgiggity-be", "/profile/search/act/" + name),
    searchProfile: name => requests.get("/profile/search/all/" + name),
    searchOtherAct: name => requests.get(`/profile/search/otheract/${name}`),
    searchAgent: name => requests.get(`/profile/search/agent/${name}`),
    searchAgency: name => requests.getAmplify("hotgiggity-be", `/profile/search/agency/${name}`),
    searchMemberVenueProfile: name => requests.getAmplify("hotgiggity-be", `/profile/search/member/${name}`),
    checkVanityUrl: (vanityUrl, profileId) => requests.getAmplify("hotgiggity-be", `/profile/vanity/${vanityUrl}/${profileId}`),

    getMusicianDashboard: (id, start, end) => requests.getAmplify("hotgiggity-be", "/profile/musician/dashboard/" + id + "?start=" + start + "&end=" + end),
    getMusicianDashboardMain: (id, start, end) => requests.getAmplify("hotgiggity-be", "/profile/musician/dashboard/main/" + id + "?start=" + start + "&end=" + end),
    getMusicianDashboardRequests: (id, start, end) => requests.getAmplify("hotgiggity-be", "/profile/musician/dashboard/request/" + id + "?start=" + start + "&end=" + end),
    getStaffDashboard: (id, start, end, organisationId, stateId, regionId, venueId) =>
        requests.getAmplify("hotgiggity-be",
            "/profile/staff/dashboard/" +
            id +
            "?start=" +
            start +
            "&end=" +
            end +
            "&organisationId=" +
            organisationId +
            "&stateId=" +
            stateId +
            "&regionId=" +
            regionId +
            "&venueId=" +
            venueId
        ),
    getAgentDashboard: (id, start, end, venueId, consultantId) =>
        requests.getAmplify("hotgiggity-be", "/profile/agent/dashboard/" + id + "?start=" + start + "&end=" + end + "&venueId=" + venueId + "&consultantId=" + consultantId),
        getAgentDashboardMain: (id, start, end, venueId, consultantId) =>
        requests.getAmplify("hotgiggity-be", "/profile/agent/dashboard/mainv2/" + id + "?start=" + start + "&end=" + end + "&venueId=" + venueId + "&consultantId=" + consultantId),
        getAgentBookingRequestDashboard: (id, start, end, venueId, consultantId) =>
        requests.getAmplify("hotgiggity-be", "/profile/agent/dashboard/request/" + id + "?start=" + start + "&end=" + end + "&venueId=" + venueId + "&consultantId=" + consultantId),
        getAgentDashboardVenue: (id, start, end, venueId, consultantId) =>
        requests.getAmplify("hotgiggity-be", "/profile/agent/dashboard/venue/" + id + "?start=" + start + "&end=" + end + "&venueId=" + venueId + "&consultantId=" + consultantId),
    createTermCondition: data => requests.postAmplify("hotgiggity-be", `/profile/termcondition`, data),
    loadTermCondition: id => requests.getAmplify("hotgiggity-be", `/profile/${id}/termcondition`),
    getMyVenues: (page) => requests.getAmplify("hotgiggity-be", `/venue/v2?limit=10&page=${page}`),
    getMyVenuesNoImage: () => requests.getAmplify("hotgiggity-be", `/venue/noimage`),
    getGoogleCalendars: () => requests.get("/user/me/google-calendar"),
    getQuickBooks: () => requests.get("/user/me/quickbooks"),
    getQuickBooksCustomers: (profileId, invoiceId) => requests.get(`/profile/${profileId}/quickbooks/customers?invoiceId=${invoiceId}`),
    getQuickBooksVendors: (profileId, invoiceId) => requests.get(`/profile/${profileId}/quickbooks/vendors?invoiceId=${invoiceId}`),
    getQuickBooksItems: profileId => requests.get(`/profile/${profileId}/quickbooks/items`),
    getQuickBooksTaxCodes: profileId => requests.get(`/profile/${profileId}/quickbooks/taxcodes`),
    getQuickBooksExpenses: profileId => requests.get(`/profile/${profileId}/quickbooks/expenses`),
    getQuickBooksInvoice: (profileId, invoiceId) => requests.get(`/profile/${profileId}/quickbooks/invoice/${invoiceId}`),
    unlinkGoogleCalendars: () => requests.get("/user/me/unlink-google-calendar"),
    canAgentInviteAct: (agentId, actId) => requests.get(`/profile/check/agent/invite/act?agentId=${agentId}&actId=${actId}`),
    canAgentInviteVenue: (agentId, venueId) => requests.get(`/profile/check/agent/invite/venue?agentId=${agentId}&venueId=${venueId}`),
    getSearchAllProfiles:  name => requests.getAmplify("hotgiggity-be", "/profile/searchProfile/all/" + name),
    setToggleAcknowledgeHirePayment: id => requests.putAmplify("hotgiggity-be", `/profile/toggle/hasAcknowledgeHirerPayment/${id}`),
    setHasSeenScheduleIntro: id => requests.putAmplify("hotgiggity-be", `/profile/${id}/schedule-intro-seen`),
};

const MusicianGeneralProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/musician/general/${profile.id}`, profile),
    create: profile => requests.postAmplify("hotgiggity-be", "/profile/musician/general", profile)
};

const AgentVenueContact = {
    get: agentVenueId => requests.getAmplify("hotgiggity-be", `/agentVenueContact/${agentVenueId}`),
    create: data => requests.postAmplify("hotgiggity-be", "/agentVenueContact", data)
};

const Xero = {
    connectXero : (body) => requests.postAmplify("hotgiggity-be", `/xero/exchangeToken`,body),
    getListOfAccounts : (profileId) => requests.getAmplify("hotgiggity-be", `/xero/accounts/${profileId}`),
    mapAccounts: (profileId,body) => requests.postAmplify("hotgiggity-be", `/xero/mapAccount/${profileId}`,body),
    getListXeroMappedContacts : (profileId) => requests.getAmplify("hotgiggity-be", `/xero/${profileId}/mappedcontacts`),
    getXeroContacts : (profileId) => requests.getAmplify("hotgiggity-be", `/xero/contacts/${profileId}`),
    createXeroContacts :(profileId, contactId) => requests.postAmplify("hotgiggity-be", `/xero/${profileId}/contacts/${contactId}`),
    mapExistingXeroContact :(body) => requests.postAmplify("hotgiggity-be", `/xero/createContact`,body),
    deleteContactXero :(id) => requests.putAmplify("hotgiggity-be", `/xero/deleteContact/${id}`),
    updateContactXero: (id,data) => requests.putAmplify("hotgiggity-be", `/xero/contact/${id}/mapped`,data),
    integrateIncomingInvoice: (profileId,data) => requests.postAmplify("hotgiggity-be", `/xero/createBill/${profileId}`,data),
    integrateOutgoingInvoice: (profileId,data) => requests.postAmplify("hotgiggity-be", `/xero/createInvoice/${profileId}`,data),
    disconnect: (profileId, xeroReset) => requests.putAmplify("hotgiggity-be", `/xero/${profileId}/disconnect`, {isReset: xeroReset}),
    getInvoiceXeroContactById : (profileId,invoiceId) => requests.getAmplify("hotgiggity-be", `/Xerocustomers/${profileId}/invoice/${invoiceId}`),
    getMappedInvoiceXeroContact : (profileId,invoiceId) => requests.getAmplify("hotgiggity-be", `/Xerocustomers/${profileId}/mapped/invoice/${invoiceId}`),
    createInvoiceXeroContact: (profileId,data) => requests.postAmplify("hotgiggity-be", `/Xerocustomers/${profileId}`,data),
    createMappedInvoiceXeroContact: (data) => requests.postAmplify("hotgiggity-be", `/Xerocustomers/mapped/invoice`,data),
    updateInvoiceXeroContact: (profileId,invoiceId,data) => requests.putAmplify("hotgiggity-be", `/Xerocustomers/${profileId}/invoice/${invoiceId}`, data),
    updateMapInvoiceXeroContact: (data) => requests.putAmplify("hotgiggity-be", `/Xerocustomers/mapped/invoice`, data),
    deleteMapInvoiceXeroContact: (data) => requests.putAmplify("hotgiggity-be", `/Xerocustomers/mapped/delete`, data),
    getXeroTenantId: (profileId) => requests.getAmplify("hotgiggity-be", `/xero/connection/${profileId}`),
    mapXeroTenant: (data) => requests.postAmplify("hotgiggity-be", `/xero/initialMap`,data),
    deleteXeroInvoice: (profileId,invoiceId) => requests.putAmplify("hotgiggity-be", `/xero/${profileId}/unsyncSendtoAccountXero/${invoiceId}`),
    mapSuperSetting: (id,body) => requests.postAmplify("hotgiggity-be", `/xero/mapSuperSetting/${id}`,body),
    submitPayment: (data) => requests.postAmplify("hotgiggity-be", `/xero/submit-payment`, data),
    syncPayment: (paymentId) => requests.postAmplify("hotgiggity-be", `/xero/sync-payment/${paymentId}`),
}


const XeroEmployee = {
 getMappedXero : (id) => requests.getAmplify("hotgiggity-be", `/xero/${id}/employeeXero`),
 get: (id) => requests.getAmplify("hotgiggity-be", `/xero/${id}/employees`),
 create: (profileId,contactId) => requests.postAmplify("hotgiggity-be", `/xero/${profileId}/employee/${contactId}`),
  update: (id,data) => requests.putAmplify("hotgiggity-be", `/xero/${id}/employeeXero`, data),
 mapExisting :(body) => requests.postAmplify("hotgiggity-be", `/xero/employee/createExisting`,body),
 delete :(id) => requests.putAmplify("hotgiggity-be", `/xero/${id}/employeeXero/deleted`)
 
 
}

const XeroCalendar = {
 get : (id) => requests.getAmplify("hotgiggity-be", `/xero/${id}/calendar`),
}

const Admin = {
    getStats: (startDate, endDate) => requests.getAmplify("hotgiggity-be", `/admin/stats?startDate=${startDate}&endDate=${endDate}`),
    getActsStats: (startDate, endDate) => requests.getAmplify("hotgiggity-be", `/admin/stats/acts?startDate=${startDate}&endDate=${endDate}`),
    getBookingsStats: (startDate, endDate) => requests.getAmplify("hotgiggity-be", `/admin/stats/bookings?startDate=${startDate}&endDate=${endDate}`),
    getVenuesStats: (startDate, endDate) => requests.getAmplify("hotgiggity-be", `/admin/stats/venues?startDate=${startDate}&endDate=${endDate}`)
};

const MusicianDesignProfile = {
    load: id => requests.getAmplify("hotgiggity-be", `/profile/musician/design/${id}`),
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/musician/design/${profile.id}`, profile),
    create: profile => requests.post("/profile/musician/design", profile)
};

const MusicianSocialProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/musician/social/${profile.id}`, profile),
    create: profile => requests.post("/profile/musician/social", profile)
};

const MusicianFinancialProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/musician/financial/${profile.id}`, profile),
    create: profile => requests.post("/profile/musician/financial", profile)
};

const MusicianInsuranceProfile = {
    load: id => requests.getAmplify("hotgiggity-be", `/profile/musician/insurance/${id}`),
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/musician/insurance/${profile.id}`, profile),
    create: profile => requests.post("/profile/musician/insurance", profile),
    uploadDocument: (profileId, acceptedFiles) => requests.postAmplify(`hotgiggity-be`, `/document/insurance/${profileId}`, acceptedFiles),
    downloadDocument: guid => requests.getFile(`/document/${guid}`),
    deleteDocument: guid => requests.delAmplify(`hotgiggity-be`, `/document/${guid}`)
};

const Document = {
    save: (profileId, documents) => requests.postAmplify("hotgiggity-be", `/document/general/${profileId}`, documents),
    getByProfile: (profileId, documentType) => {
        let url = `/document/profile/${profileId}`;
        if (documentType !== undefined) {
            url += `?documentType=${documentType}`;
        }
        return requests.getAmplify("hotgiggity-be", url);
    },
    delete: guid => requests.delAmplify("hotgiggity-be", `/document/${guid}`)
};

const MusicianPrivacyProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/musician/privacy/${profile.id}`, profile),
    create: profile => requests.post("/profile/musician/privacy", profile)
};

const MusicianEmbedProfile = {
    update: profile => requests.put(`/profile/musician/embed/${profile.id}`, profile),
    create: profile => requests.post("/profile/musician/embed", profile)
};

const AgentGeneralProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/agent/general/${profile.id}`, profile),
    create: profile => requests.postAmplify("hotgiggity-be", "/profile/agent/general", profile)
};

const AgentDesignProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/agent/design/${profile.id}`, profile),
    create: profile => requests.postAmplify("hotgiggity-be", "/profile/agent/design", profile)
};

const AgentSocialProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/agent/social/${profile.id}`, profile),
    create: profile => requests.postAmplify("hotgiggity-be", "/profile/agent/social", profile)
};

const AgentFinancialProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/agent/financial/${profile.id}`, profile),
    create: profile => requests.postAmplify("hotgiggity-be", "/profile/agent/financial", profile)
};

const AgentInsuranceProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/agent/insurance/${profile.id}`, profile)
};

const AgentPrivacyProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/agent/privacy/${profile.id}`, profile),
    create: profile => requests.postAmplify("hotgiggity-be", "/profile/agent/privacy", profile)
};

const StaffGeneralProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/staff/general/${profile.id}`, profile),
    create: profile => requests.postAmplify("hotgiggity-be", "/profile/staff/general", profile)
};

const GooglePlace = {
    getPlaceId: (key,placeId) => requests.googlePlace(key,placeId),
    
}


const PrivateHireGeneralProfile = { 
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/privateHire/general/${profile.id}`, profile),
    create: profile => requests.postAmplify("hotgiggity-be", "/profile/privateHire/general", profile)
};

const StaffDesignProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/staff/design/${profile.id}`, profile),
    create: profile => requests.post("/profile/staff/design", profile)
};

const StaffSocialProfile = {
    update: profile => requests.put(`/profile/staff/social/${profile.id}`, profile),
    create: profile => requests.post("/profile/staff/social", profile)
};

const StaffFinancialProfile = {
    update: profile => requests.put(`/profile/staff/financial/${profile.id}`, profile),
    create: profile => requests.post("/profile/staff/financial", profile)
};

const StaffPrivacyProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/staff/privacy/${profile.id}`, profile),
    create: profile => requests.post("/profile/staff/privacy", profile)
};

const VenueGeneralProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/venue/general/${profile.id}`, profile),
    create: profile => requests.postAmplify("hotgiggity-be", "/profile/venue/general", profile)
};

const ProductionGeneralProfile = {
    update: profile => requests.put(`/profile/production/general/${profile.id}`, profile),
    create: profile => requests.post("/profile/production/general", profile)
};

const ProductionDesignProfile = {
    update: profile => requests.put(`/profile/production/design/${profile.id}`, profile),
    create: profile => requests.post("/profile/production/design", profile)
};

const ProductionSocialProfile = {
    update: profile => requests.put(`/profile/production/social/${profile.id}`, profile),
    create: profile => requests.post("/profile/production/social", profile)
};

const ProductionFinancialProfile = {
    update: profile => requests.put(`/profile/production/financial/${profile.id}`, profile),
    create: profile => requests.post("/profile/production/financial", profile)
};

const ProductionPrivacyProfile = {
    update: profile => requests.put(`/profile/production/privacy/${profile.id}`, profile),
    create: profile => requests.post("/profile/production/privacy", profile)
};

const ProductionEmbedProfile = {
    update: profile => requests.put(`/profile/production/embed/${profile.id}`, profile),
    create: profile => requests.post("/profile/production/embed", profile)
};

const DjGeneralProfile = {
    update: profile => requests.put(`/profile/dj/general/${profile.id}`, profile),
    create: profile => requests.post("/profile/dj/general", profile)
};

const DjDesignProfile = {
    update: profile => requests.put(`/profile/dj/design/${profile.id}`, profile),
    create: profile => requests.post("/profile/dj/design", profile)
};

const PrivateHireDesignProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/privatehire/design/${profile.id}`, profile),
    create: profile => requests.postAmplify("hotgiggity-be", "/profile/privatehire/design", profile)
};

const DjSocialProfile = {
    update: profile => requests.put(`/profile/dj/social/${profile.id}`, profile),
    create: profile => requests.post("/profile/dj/social", profile)
};

const DjFinancialProfile = {
    update: profile => requests.put(`/profile/dj/financial/${profile.id}`, profile),
    create: profile => requests.post("/profile/dj/financial", profile)
};

const DjPrivacyProfile = {
    update: profile => requests.put(`/profile/dj/privacy/${profile.id}`, profile),
    create: profile => requests.post("/profile/dj/privacy", profile)
};

const DjEmbedProfile = {
    update: profile => requests.put(`/profile/dj/embed/${profile.id}`, profile),
    create: profile => requests.post("/profile/dj/embed", profile)
};

const VenueDesignProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/venue/design/${profile.id}`, profile),
    create: profile => requests.post("/profile/venue/design", profile)
};

const VenueSocialProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/venue/social/${profile.id}`, profile),
    create: profile => requests.post("/profile/venue/social", profile)
};

const VenueFinancialProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/venue/financial/${profile.id}`, profile),
    create: profile => requests.post("/profile/venue/financial", profile)
};

const VenueMemberProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/venue/member/${profile.id}`, profile),
    create: profile => requests.post("/profile/venue/member", profile)
};

const VenuePrivacyProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/venue/privacy/${profile.id}`, profile),
    create: profile => requests.post("/profile/venue/privacy", profile)
};

const PrivateHirePrivacyProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/privatehire/privacy/${profile.id}`, profile),
    create: profile => requests.post("/profile/venue/privacy", profile)
};



const VenueMenuProfile = {
    get: profileId => requests.getAmplify('hotgiggity-be', `/profile/venue/menu/${profileId}`),
    loadProfile: profile => requests.get(`/profile/venue/menu/${profile.id}`),
    create: profile => requests.putAmplify("hotgiggity-be", `/profile/venue/menu/${profile.id}`, profile)
};

const ActDuplicateProfile = {
    duplicate: actId => requests.postAmplify('hotgiggity-be', `/profile/act/duplicate/${actId}`)
};

const UserFavourite = {
    addUserFavourite: data => requests.postAmplify("hotgiggity-be", "/userFavourite/create", data),
    removeUserFavourite: profileId => requests.delAmplify(`hotgiggity-be`, `/userFavourite/${profileId}/delete`),
    getUserFavouriteActs: () => requests.getAmplify("hotgiggity-be", `/userFavourite/acts`)

}
const ActGeneralProfile = {
    update: profile => requests.putAmplify('hotgiggity-be', `/profile/act/general/${profile.id}`, profile),
    create: profile => requests.postAmplify("hotgiggity-be", "/profile/act/general", profile)
};

const ActDesignProfile = {
    update: profile => requests.putAmplify('hotgiggity-be', `/profile/act/design/${profile.id}`, profile),
    create: profile => requests.post("/profile/act/design", profile)
};

const ActSocialProfile = {
    update: profile => requests.putAmplify('hotgiggity-be', `/profile/act/social/${profile.id}`, profile),
    create: profile => requests.post("/profile/act/social", profile)
};

const ActFinancialProfile = {
    update: profile => requests.put(`/profile/act/financial/${profile.id}`, profile),
    create: profile => requests.post("/profile/act/financial", profile)
};

const ActPrivacyProfile = {
    update: profile => requests.putAmplify("hotgiggity-be", `/profile/act/privacy/${profile.id}`, profile),
    create: profile => requests.post("/profile/act/privacy", profile)
};

const ActRoster = {
    getActRoster: actId => requests.getAmplify("hotgiggity-be", `/actRoster/getList/${actId}`),
    getActProductionRoster: actId => requests.get(`/actRoster/production/${actId}`),
    update: actRoster => requests.postAmplify("hotgiggity-be", "/actRoster/update", actRoster),
    productionUpdate: actRoster => requests.post("/actRoster/production", actRoster),
    getRosterByProfileId: profileId => requests.getAmplify("hotgiggity-be", `/roster/profile/${profileId}`)
};

const Roster = {
    inviteNew: (actId, invite) => requests.postAmplify("hotgiggity-be", `/roster/invite/${actId}`, invite),
    inviteProduction: (actId, invite) => requests.post(`/roster/invite/${actId}/production`, invite),
    acceptDecline: (actId, profileId, accept) => requests.postAmplify("hotgiggity-be", `/roster/acceptDecline/${actId}/${profileId}/${accept}`),
    quit: (actId, profileId) => requests.delAmplify("hotgiggity-be", `/roster/${actId}/quit/${profileId}`)
};

const ProfileRelationship = {
    //AgentActRoster
    getAgentActRequest: () => requests.getAmplify("hotgiggity-be", `/profileRelationshipRequest/agentAct/agent`),
    getActAgentRequest: () => requests.get(`/profileRelationshipRequest/agentAct/act`),
    getMusicianActAgentRequest: () => requests.getAmplify("hotgiggity-be", `/profileRelationshipRequest/agentAct/musician`),

    getAgentMusicianRequest: () => requests.get(`/profileRelationshipRequest/agentMusicianRequest`),
    getMusicianAgentRequest: () => requests.get(`/profileRelationshipRequest/musicianAgentRequest`),

    getAgentVenueRequets: () => requests.getAmplify("hotgiggity-be", `/profileRelationshipRequest/agentVenueRequest`),
    //getVenueAgentRequest: venueId => requests.get(`/profileRelationshipRequest/venueAgentRequest/${venueId}`),
    getVenueAgentRequest: venueId => requests.getAmplify("hotgiggity-be", `/profileRelationshipRequest/venueAgentRequest/${venueId}`),
    getStaffVenuesAgentRequests: staffId => requests.getAmplify("hotgiggity-be", `/profileRelationshipRequest/staffAgentRequest/${staffId}`),
    //venue act roster

    getVenueActRoster: venueId => requests.getAmplify("hotgiggity-be", `/profileRelationshipRequest/venueAct/${venueId}/venue`),
    getStaffActRoster: staffId => requests.getAmplify("hotgiggity-be", `/profileRelationshipRequest/venueAct/${staffId}/staff`),
    getMusicianActVenueRoster: () => requests.getAmplify("hotgiggity-be", `/profileRelationshipRequest/venueAct/musician`),
    getActVenueRoster: actId => requests.get(`/profileRelationshipRequest/venueAct/${actId}/act`),

    invite2: requestDetail => requests.postAmplify("hotgiggity-be", `/profileRelationshipRequest/invite/v2`, requestDetail),
    invite: requestDetail => requests.postAmplify("hotgiggity-be", `/profileRelationshipRequest/invite`, requestDetail),
    inviteMany: requestDetails => requests.postAmplify("hotgiggity-be", `/profileRelationshipRequest/inviteMany`, requestDetails),
    accept: requestDetail => requests.postAmplify("hotgiggity-be", `/profileRelationshipRequest/accept`, requestDetail),
    acceptMany: requestDetails => requests.postAmplify("hotgiggity-be", `/profileRelationshipRequest/acceptMany`, requestDetails),
    decline: requestId => requests.postAmplify("hotgiggity-be", `/profileRelationshipRequest/decline/${requestId}`),
    declineMany: requestIds => requests.postAmplify("hotgiggity-be", `/profileRelationshipRequest/declineMany`, requestIds),
    remove: requestId => requests.delAmplify("hotgiggity-be", `/profileRelationshipRequest/remove/${requestId}`),
    removeMany: requestIds => requests.postAmplify("hotgiggity-be", `/profileRelationshipRequest/removeMany`, requestIds)
};

const AgentAct = {
    getAgentActRosterSimple: agentId => requests.getAmplify("hotgiggity-be", `/agentAct/${agentId}/agentActRoster/simple`),
    getAgentActRosterSimpleV2: agentId => requests.getAmplify("hotgiggity-be", `/agentAct/${agentId}/agentActRoster/simple/v2`),
    getAgentActRoster: agentId => requests.getAmplify("hotgiggity-be", `/agentAct/${agentId}/agentActRoster`),
    getAgentActRosterV2: (agentId, limit, page, criteria = {}) => requests.getAmplify("hotgiggity-be", `/agentAct/${agentId}/agentActRoster/v2?${rosterQueryString(limit, page, criteria)}`),
    getAgentActRosterV2WithSearch: (agentId, limit, page, search) => {
        return AgentAct.getAgentActRosterV2(agentId, limit, page, { search });
    },

    
    getAgentActMyActs: agentId => requests.getAmplify("hotgiggity-be", `/agentAct/${agentId}/myActs`),
    getActAgents: actId => requests.get(`/agentAct/${actId}/actAgents`),
    getMusicianAgents: musicianId => requests.getAmplify("hotgiggity-be", `/agentAct/${musicianId}/musicianAgents`),

    getConsultantActRoster: consultantId => requests.getAmplify("hotgiggity-be", `/agentAct/${consultantId}/consultantActRoster`),
    getConsultantActRosterSimple: consultantId => requests.getAmplify("hotgiggity-be", `/agentAct/${consultantId}/consultantActRoster/simple`),
    delete: id => requests.delAmplify("hotgiggity-be", `/agentAct/${id}/delete`),
    deleteMany: ids => requests.postAmplify("hotgiggity-be", `/agentAct/deleteMany`, ids),
    getAgentAvailableActs: (agentId, booking) => requests.postAmplify("hotgiggity-be", `/agentAct/${agentId}/agentAvailableAct`, booking), 
    updateAgentAct: (agentActId, data) => requests.putAmplify("hotgiggity-be", `/agentAct/${agentActId}/updateInvoiceType`, data),
    updateAgentActFromAct: (data) => requests.putAmplify("hotgiggity-be", `/agentAct/updateInvoiceType/fromAct`, data)
};

const AgentMusician = {
    getAgentMusicianRoster: agentId => requests.get(`/agentMusician/getAgentMusicianRoster/${agentId}`),
    getAgentMusicianActRoster: agentId => requests.get(`/agentMusician/getAgentMusicianActRoster/${agentId}`),
    getMusicianAgents: musicianId => requests.get(`/agentMusician/getMusicianAgents/${musicianId}`)
};

const AgentVenues = {
    getById: id => requests.get(`/agentVenue/${id}/getById`),
    //getMyVenuesAgent: venueId => requests.get(`/agentVenue/getMyVenueAgents/${venueId}`),
    getMyVenuesAgent: venueId => requests.getAmplify("hotgiggity-be", `/agentVenue/getMyVenueAgents/${venueId}`),
    getMyVenueRosterSocial: agentId => requests.getAmplify("hotgiggity-be", `/agentVenue/getMyVenueRoster/social/${agentId}/simple`),
    
    getMyVenueRoster: agentId => requests.getAmplify("hotgiggity-be", `/agentVenue/getMyVenueRoster/${agentId}`),
    getMyVenueRosterV2: (agentId,limit,page) => requests.getAmplify("hotgiggity-be", `/agentVenue/getMyVenueRoster/${agentId}/v2?limit=${limit}&page=${page}`),
    getMyVenueRosterV2WithSearch: (agentId, limit, page, search) => {
        let url = `/agentVenue/getMyVenueRoster/${agentId}/v2?limit=${limit}&page=${page}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        return requests.getAmplify("hotgiggity-be", url);
    },
    getMyVenueRosterSimple: agentId => requests.getAmplify("hotgiggity-be", `/agentVenue/getMyVenueRoster/${agentId}/simple`),
    getStaffVenuesAgent: staffId => requests.getAmplify("hotgiggity-be", `/agentVenue/${staffId}/staff`),
    getConsultantVenueRoster: consultantId => requests.getAmplify("hotgiggity-be", `/agentVenue/${consultantId}/consultant`),
    getConsultantVenueRosterV2: (consultantId, limit, page) => requests.getAmplify("hotgiggity-be", `/agentVenue/${consultantId}/consultant/v2?limit=${limit}&page=${page}`),
    getConsultantVenueRosterV2WithSearch: (consultantId, limit, page, search) => {
        let url = `/agentVenue/${consultantId}/consultant/v2?limit=${limit}&page=${page}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        return requests.getAmplify("hotgiggity-be", url);
    },
    getConsultantVenueRosterSimple: consultantId => requests.getAmplify("hotgiggity-be", `/agentVenue/${consultantId}/consultant/simple`),
    deleteAgentVenue: (id, profileId) => requests.delAmplify("hotgiggity-be", `/agentVenue/${id}/delete/${profileId}`),
    deleteAgentVenues: (ids, profileId) => requests.postAmplify("hotgiggity-be", `/agentVenue/deleteMany/${profileId}`, ids),
    edit: details => requests.putAmplify("hotgiggity-be", `/agentVenue/edit`, details),
    updateSuperInclude: (agentVenueId, data) => requests.putAmplify("hotgiggity-be", `/agentVenue/${agentVenueId}/updateDefaultSuper`, data),
};

const SuperLedgers = {
    getLedgersByPayeeId :  (payerId,limit,page, startDate, endDate, contactId, venueId, superLedgerId, organisationId, stateId, regionId, status) => requests.getAmplify("hotgiggity-be", `/superLedger/${payerId}/payee?limit=${limit}&page=${page}&startDate=${startDate}&endDate=${endDate}&venueId=${venueId}&contactId=${contactId}&superLedgerId=${superLedgerId}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&status=${status}`),
    getLedgersByPayerId :  (payeeId,limit,page, startDate, endDate, contactId, venueId, superLedgerId, organisationId, stateId, regionId, status) => requests.getAmplify("hotgiggity-be", `/superLedger/${payeeId}/payer?limit=${limit}&page=${page}&startDate=${startDate}&endDate=${endDate}&venueId=${venueId}&contactId=${contactId}&superLedgerId=${superLedgerId}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&status=${status}`),
    getLedgersGroupedByPayeeId: (payerId, startDate, endDate, contactId, venueId, superLedgerId, organisationId, stateId, regionId, status) => requests.getAmplify("hotgiggity-be", `/superLedger/${payerId}/payee/grouped?startDate=${startDate}&endDate=${endDate}&venueId=${venueId}&contactId=${contactId}&superLedgerId=${superLedgerId}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&status=${status}`),
    getLedgersGroupedByPayerId: (payeeId, startDate, endDate, contactId, venueId, superLedgerId, organisationId, stateId, regionId, status) => requests.getAmplify("hotgiggity-be", `/superLedger/${payeeId}/payer/grouped?startDate=${startDate}&endDate=${endDate}&venueId=${venueId}&contactId=${contactId}&superLedgerId=${superLedgerId}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&status=${status}`),
    payLedger: (profileId, id, data) => requests.putAmplify("hotgiggity-be", `/superLedgerPayments/${id}/pay/${profileId}`, data),
    unpayLedger: (profileId, id) => requests.putAmplify("hotgiggity-be", `/superLedgerPayments/${id}/unpay/${profileId}`),
    paySuperLedgersManually: (data) => requests.postAmplify("hotgiggity-be", `/superLedgerPayments/pay/manual`, data),
    validateSuperAnnuation: (data) => requests.postAmplify("hotgiggity-be", `/superLedger/validate`, data)
}

const SuperLedgerPayments = {
    getPaymentsByPayerId: (payerId, params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.startDate) queryParams.append('startDate', params.startDate);
        if (params.endDate) queryParams.append('endDate', params.endDate);
        if (params.status) queryParams.append('status', params.status);
        if (params.sourceType) queryParams.append('sourceType', params.sourceType);
        if (params.page) queryParams.append('page', params.page);
        if (params.limit) queryParams.append('limit', params.limit);
        if (params.venueId) queryParams.append('venueId', params.venueId);
        if (params.organisationId) queryParams.append('organisationId', params.organisationId);
        if (params.stateId) queryParams.append('stateId', params.stateId);
        if (params.regionId) queryParams.append('regionId', params.regionId);
        return requests.getAmplify("hotgiggity-be", `/superLedgerPayments/payer/${payerId}?${queryParams.toString()}`);
    },
    getPaymentsByPayeeId: (payeeId, params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.startDate) queryParams.append('startDate', params.startDate);
        if (params.endDate) queryParams.append('endDate', params.endDate);
        if (params.status) queryParams.append('status', params.status);
        if (params.sourceType) queryParams.append('sourceType', params.sourceType);
        if (params.page) queryParams.append('page', params.page);
        if (params.limit) queryParams.append('limit', params.limit);
        if (params.venueId) queryParams.append('venueId', params.venueId);
        if (params.organisationId) queryParams.append('organisationId', params.organisationId);
        if (params.stateId) queryParams.append('stateId', params.stateId);
        if (params.regionId) queryParams.append('regionId', params.regionId);
        return requests.getAmplify("hotgiggity-be", `/superLedgerPayments/payee/${payeeId}?${queryParams.toString()}`);
    },
    getPaymentById: (paymentId, profileId) => {
        return requests.getAmplify("hotgiggity-be", `/superLedgerPayments/${paymentId}/profile/${profileId}`);
    },
    deletePayment: (paymentId) => {
        return requests.delAmplify("hotgiggity-be", `/superLedgerPayments/${paymentId}`);
    },
    excludeLedgersFromPayment: (paymentId, ledgerIds) => {
        return requests.postAmplify("hotgiggity-be", `/superLedgerPayments/${paymentId}/exclude-ledgers`, { ledgerIds });
    },
    removeLedgersFromPayment: (paymentId, paymentLedgerIds) => {
        return requests.postAmplify("hotgiggity-be", `/xero/payments/${paymentId}/remove-ledgers`, { paymentLedgerIds });
    },
    markPaymentAsSettled: (paymentId) => {
        return requests.postAmplify("hotgiggity-be", `/superLedgerPayments/${paymentId}/mark-settled`);
    }
}

const HgSuperPayAddon = {
    getStatus: (profileId) => requests.getAmplify("hotgiggity-be", `/paymentSubscription/${profileId}`),
    subscribe: (profileId, isOrganisation) => requests.postAmplify("hotgiggity-be", `/paymentSubscription/${profileId}/subscribe`, { isOrganisation: isOrganisation || false }),
    cancel: (profileId) => requests.delAmplify("hotgiggity-be", `/paymentSubscription/${profileId}`),
    // Card management (profile-scoped — resolves to the correct Stripe customer automatically)
    getCard: (profileId) => requests.getAmplify("hotgiggity-be", `/paymentSubscription/${profileId}/card`),
    addCard: (profileId, isOrganisation) => requests.postAmplify("hotgiggity-be", `/paymentSubscription/${profileId}/card`, { isOrganisation: isOrganisation || false }),
    setDefaultCard: (profileId, paymentMethodId) => requests.patchAmplify("hotgiggity-be", `/paymentSubscription/${profileId}/card`, { paymentMethodId }),
    deleteCard: (profileId, paymentMethodId) => requests.delWithBodyAmplify("hotgiggity-be", `/paymentSubscription/${profileId}/card`, { paymentMethodId }),
    // Billing history (live from Stripe for this venue's own customer)
    getBillingHistory: (profileId, limit = 50) => requests.getAmplify("hotgiggity-be", `/paymentSubscription/${profileId}/billing-history?limit=${limit}`),
};

const HgSuperPay = {
    acknowledgeMvrAnnouncement: profileId => requests.postAmplify(
        "hotgiggity-be", `/hgSuper/profile/${profileId}/mvr-announcement/acknowledge`,
        { mvrAnnouncementRead: true }),
    getEmployeeStatus: (profileId) => requests.getAmplify("hotgiggity-be", `/hgSuper/employee/${profileId}`),
    syncEmployee: (profileId, employerProfileId) => requests.postAmplify("hotgiggity-be", `/hgSuper/v2/sync-employee/${profileId}`, { employerProfileId }),
    updateEmployee: (profileId, employerProfileId) => requests.putAmplify("hotgiggity-be", `/hgSuper/v2/employee/${profileId}`, { employerProfileId }),
    submitMvr: (profileId, employerProfileId) => requests.postAmplifyStrict("hotgiggity-be", `/hgSuper/v2/mvr/submit/${profileId}`, { employerProfileId }),
    getEmployeeMapping: (profileId, page = 1, limit = 20, search = "", mapped = null) => {
        const params = [`page=${page}`, `limit=${limit}`];
        const trimmedSearch = String(search || "").trim();
        if (trimmedSearch) {
            params.push(`search=${encodeURIComponent(trimmedSearch)}`);
        }
        if (mapped === true || mapped === false) {
            params.push(`mapped=${mapped}`);
        }
        return requests.getAmplify("hotgiggity-be", `/hgSuper/employee-mapping/v2/${profileId}?${params.join("&")}`);
    },
    deleteEmployeeMapping: (profileId, employerProfileId) => requests.delWithBodyAmplify("hotgiggity-be", `/hgSuper/employee-mapping/${profileId}`, { employerProfileId }),
    getEmployeeSuper: (profileId) => requests.getAmplify("hotgiggity-be", `/hgSuper/employee-super/${profileId}`),
    getEmployeePreview: (contactId, employerProfileId) => requests.getAmplify("hotgiggity-be", `/hgSuper/employee-preview/${contactId}?employerProfileId=${employerProfileId}`),
    validateLedgers: (data) => requests.postAmplify("hotgiggity-be", `/hgSuper/validate-ledgers`, data),
    validatePayees: (data) => requests.postAmplify("hotgiggity-be", `/hgSuper/validate-payees`, data),
    submitPayment: (data) => requests.postAmplify("hotgiggity-be", `/hgSuper/submit-payment`, data),
    getEffectivePayer: (profileId) => requests.getAmplify("hotgiggity-be", `/hgSuper/effective-payer/${profileId}`),
    onboardEmployer: (data) => requests.postAmplify("hotgiggity-be", `/hgSuper/onboard-employer`, data),
    getEmployerStatus: (profileId, venueId) => {
        const url = venueId
            ? `/hgSuper/employer-status/${profileId}?venueId=${venueId}`
            : `/hgSuper/employer-status/${profileId}`;
        return requests.getAmplify("hotgiggity-be", url);
    },
    checkVenueCustomisation: (venueId) => requests.getAmplify("hotgiggity-be", `/hgSuper/venue-customised/${venueId}`),
    setVenueCustomisation: (venueId, isCustomised) => requests.putAmplify("hotgiggity-be", `/hgSuper/venue-customised/${venueId}`, { isCustomised }),
    syncPaymentStatus: (paymentId) => requests.getAmplify("hotgiggity-be", `/hgSuper/sync-payment-status/${paymentId}`),
    getPaymentMemberOutcomes: (paymentId) => requests.getAmplify("hotgiggity-be", `/hgSuper/payment-member-outcomes/${paymentId}`),
    getContributionHistory: (employeeId, startDate, endDate, employerProfileId, page, limit, organisationId) => {
        const params = {};
        if (employeeId) params.employeeId = employeeId;
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;
        if (employerProfileId) params.employerProfileId = employerProfileId;
        if (page) params.page = page;
        if (limit) params.limit = limit;
        if (organisationId) params.organisationId = organisationId;
        return requests.getPlainAmplify("hotgiggity-be", `/hgSuper/contribution-history`, params);
    }
}

const VenueAct = {
    getVenueActRoster: venueId => requests.getAmplify("hotgiggity-be", `/venueActRoster/${venueId}/venue`),
    getVenueActRosterSimpleData: venueId => requests.getAmplify("hotgiggity-be", `/venueActRoster/${venueId}/venue/simple`),
    getVenueActRosterWithPagination: (venueId, limit, page, criteria = {}) => requests.getAmplify("hotgiggity-be", `/venueActRoster/${venueId}/venue/v2?${rosterQueryString(limit, page, criteria)}`),
    getStaffActRosterV2: (staffId, limit, page, criteria = {}) => requests.getAmplify("hotgiggity-be", `/venueActRoster/${staffId}/rosters/v2?${rosterQueryString(limit, page, criteria)}`),
    getMusicianActVenue: musicianId => requests.getAmplify("hotgiggity-be", `/venueActRoster/${musicianId}/musician`),
    getStaffActRoster: (staffId, criteria = {}) => {
        const query = rosterFilterQueryString(criteria);
        return requests.getAmplify("hotgiggity-be", `/venueActRoster/${staffId}/rosters${query ? `?${query}` : ""}`);
    },
    getStaffActRosterSimple: staffId => requests.getAmplify("hotgiggity-be", `/venueActRoster/${staffId}/rosters/simple`),
    getStaffActRosterUnique: staffId => requests.getAmplify("hotgiggity-be", `/venueActRoster/${staffId}/staff`),
    getStaffActRosterUniqueWithAdmin: staffId => requests.getAmplify("hotgiggity-be", `/venueActRoster/${staffId}/staff/withAdmin`),

    createMany: details => requests.postAmplify("hotgiggity-be", `/venueActRoster/createMany`, details),

    delete: (id, cancelBookings) => requests.delAmplify("hotgiggity-be", `/venueActRoster/${id}/delete/${cancelBookings}`),
    deleteMany: ids => requests.postAmplify("hotgiggity-be", `/venueActRoster/deleteMany`, ids),
    deleteMusician: (id) => requests.postAmplify("hotgiggity-be", `/venueActRoster/${id}/musician/delete`),
    getStaffAvailableActs: (staffId, bookingDetail) => requests.postAmplify("hotgiggity-be", `/venueActRoster/${staffId}/staffAvailableAct`, bookingDetail),
    updateVenueAct: (venueActId, data) => requests.putAmplify("hotgiggity-be", `/venueActRoster/${venueActId}/updateInvoiceType`, data),
    updateVenueActFromAct: (data) => requests.putAmplify("hotgiggity-be", `/venueActRoster/updateInvoiceType/fromAct`, data)

    
};

const AgentConsultant = {
    getAgentConsultants: () => requests.getAmplify("hotgiggity-be", `/agentConsultant/as/agent`),
    getAgentAgency: () => requests.getAmplify("hotgiggity-be", `/agentConsultant/as/consultant`),
    create: details => requests.postAmplify("hotgiggity-be", `/agentConsultant/create`, details),
    update: details => requests.postAmplify("hotgiggity-be", `/agentConsultant/update`, details),
    updateStatus: (id, status) => requests.putAmplify("hotgiggity-be", `/agentConsultant/update/${id}/status/${status}`),
    updateChangeAgent: (id, agentId, venue) => requests.postAmplify("hotgiggity-be", `/agentConsultant/update/${id}/agent/${agentId}`, venue),
    delete: (id, profileId) => requests.delAmplify("hotgiggity-be", `/agentConsultant/${id}/delete/${profileId}`)
};

const Image = {
    uploadProfilePicture: (profileId, acceptedFiles) => requests.postAmplify("hotgiggity-be", `/image/profile/${profileId}`, acceptedFiles),
    uploadBackgroundPicture: (profileId, acceptedFiles) => requests.postAmplify("hotgiggity-be", `/image/background/${profileId}`, acceptedFiles),
    deleteProfilePicture: imageId => requests.delAmplify("hotgiggity-be", `/image/${imageId}`),
    deleteBackgroundPicture: imageId => requests.delAmplify("hotgiggity-be", `/image/background/${imageId}`)
};

const Instrument = {
    getAll: () => requests.getAmplify("hotgiggity-be", "/instrument/getAll")
};

const Production = {
    getAll: () => requests.get("/production/all")
};

const Genre = {
    getAll: () => requests.getAmplify("hotgiggity-be", "/genre/all")
};

const VenueType = {
    getAll: () => requests.getAmplify("hotgiggity-be", "/venueType/all")
};

const ActType = {
    getAll: () => requests.getAmplify("hotgiggity-be", "/actType/all")
};

const EmbedGig = {
    getByProfileId: profileId => requests.getAmplify("hotgiggity-be", `/embedgig/${profileId}/profile`),
    createEmbedCode: data => requests.postAmplify("hotgiggity-be", `/embedgig/create/${data.profileId}`, data),
    getByOrganisationId: organisationId => requests.getAmplify("hotgiggity-be", `/embedgig/${organisationId}/organisation`),
    getOrganisationVenues: organisationId => requests.getAmplify("hotgiggity-be", `/embedgig/${organisationId}/organisation/venues`),
    createEmbedCodeOrganisation: data => requests.postAmplify("hotgiggity-be", `/embedgig/create/${data.organisationId}/organisation`, data)
};

const GigType = {
    getAll: () => requests.getAmplify("hotgiggity-be", "/gigType/all")
};

const Vibe = {
    getAll: () => requests.getAmplify("hotgiggity-be", "/vibe/all")
};

const SoundCloud = {
    getEmbed: data => requests.simplePostForSoundcloud("https://soundcloud.com/oembed", data)
};

const SuperAnnuationFee = {
    getData: (bookingDate) => requests.getAmplify("hotgiggity-be", `/superFee/${bookingDate}`)
};

const Song = {
    create: song => requests.post(`/song`, song),
    getSongs: profileId => requests.getAmplify("hotgiggity-be", `/song/profile/${profileId}`),
    addSong: (profileId, songs) => requests.postAmplify("hotgiggity-be", `/song/profile/${profileId}`, songs),
    undoAddSong: (profileId, songs) => requests.postAmplify("hotgiggity-be", `/song/profile/${profileId}/undo`, songs),
    deleteSong: (profileId, songs) => requests.postAmplify("hotgiggity-be", `/song/profile/${profileId}/delete`, songs),
    undoDeleteSong: (profileId, songs) => requests.postAmplify("hotgiggity-be", `/song/profile/${profileId}/undodelete`, songs),
    executeDeleteSong: (profileId, songs) => requests.postAmplify("hotgiggity-be", `/song/profile/${profileId}/executedelete`, songs),
    selectTopSong: (profileId, song) => requests.postAmplify("hotgiggity-be", `/song/profile/${profileId}/select`, song),
    getTopSongs: profileId => requests.get(`/song/profile/${profileId}/select`),
    update: song => requests.putAmplify("hotgiggity-be", `/song/media/${song.id}`, song)
};

const PlayedAt = {
    addPlayedAt: (profileId, playedAts) => requests.postAmplify("hotgiggity-be", `/profile/${profileId}/playedat`, playedAts),
    editPlayedAt: (profileId, playedAt) => requests.putAmplify("hotgiggity-be", `/profile/${profileId}/playedat/edit`, playedAt),
    deletePlayedAt: (profileId, playedAts) => requests.delWithBodyAmplify("hotgiggity-be", `/profile/${profileId}/playedat/delete`, playedAts)
};

const PlayedWith = {
    addPlayedWith: (profileId, playedWiths) => requests.postAmplify("hotgiggity-be", `/profile/${profileId}/playedwith`, playedWiths),
    editPlayedWith: (profileId, playedWith) => requests.putAmplify("hotgiggity-be", `/profile/${profileId}/playedwith/edit`, playedWith),
    deletePlayedWith: (profileId, playedWiths) => requests.delWithBodyAmplify("hotgiggity-be", `/profile/${profileId}/playedwith/delete`, playedWiths)
};

const Notification = {
    load: data => requests.getAmplify("hotgiggity-be", "/user/me/notifications"),
    loadPaginated: (page, limit) => requests.getAmplify("hotgiggity-be", `/user/me/notifications?page=${page}&limit=${limit}`),
    read: notificationId => requests.postAmplify("hotgiggity-be", `/notification/read/${notificationId}`),
    update: notification => requests.postAmplify("hotgiggity-be", `/notification/${notification.id}`, notification),
    delete: notificationIds => requests.delWithBodyAmplify("hotgiggity-be", `/notification/delete`, notificationIds),
    deleteAll: userId => requests.putAmplify("hotgiggity-be", `/notification/delete/all`),
    readAll: userId => requests.putAmplify("hotgiggity-be", `/notification/read/all`)
};

const NotificationSetting = {
    load: () => requests.get("/user/me/notificationsetting"),
    update: notificationSettings => requests.post(`/notificationsetting/${notificationSettings.id}`, notificationSettings)
};

const Organisation = {
    loadOrganisations: () => requests.getAmplify("hotgiggity-be", "/user/me/organisation"),
    loadRegions: () => requests.getAmplify("hotgiggity-be", "/region/user/venue"),
    load: organisationId => requests.getAmplify("hotgiggity-be", `/organisation/${organisationId}`),
    updateEmployerModel: (id, employerModel) => requests.putAmplify("hotgiggity-be", `/organisation/${id}/super-pay-setup-level`, { hgSuperPaySetupLevel: employerModel === "group" ? 1 : employerModel === "per-venue" ? 2 : null }),
    update: organisation => requests.putAmplify("hotgiggity-be", `/organisation/${organisation.id}`, organisation),
    create: organisation => requests.postAmplify("hotgiggity-be", `/organisation`, organisation),
};

const OrganisationMember = {
    loadOrg: organisationId => requests.get(`/organisation/${organisationId}/member`),
    update: organisation => requests.post(`/organisation/${organisation.id}`, organisation),
    create: organisation => requests.post("/organisation", organisation),
    checkEmailMember: email => requests.getAmplify("hotgiggity-be", `/organisation/member/${email}`),
};

const SetList = {
    load: id => requests.getAmplify("hotgiggity-be", `/setlist/${id}`),
    create: setlist => requests.postAmplify("hotgiggity-be", `/setlist`, setlist),
    update: setlist => requests.postAmplify("hotgiggity-be", `/setlist/${setlist.id}`, setlist),
    delete: id => requests.delAmplify("hotgiggity-be", `/setlist/${id}`),
    getByProfileId: profileId => requests.getAmplify("hotgiggity-be", `/setlist/profile/${profileId}`),
    getByBookingId: bookingId => requests.getAmplify("hotgiggity-be", `/booking/${bookingId}/setlists`),
    addSongs: (id, songs) => requests.postAmplify("hotgiggity-be", `/setlist/single/${id}/add`, songs),
    copyFromAct: (bookingId, actId) => requests.postAmplify("hotgiggity-be", `/booking/${bookingId}/copyAct/${actId}`)
};

const State = {
    load: stateId => requests.getAmplify("hotgiggity-be", `/state/${stateId}`),
    update: state => requests.putAmplify("hotgiggity-be", `/state/${state.id}`, state),
    create: state => requests.post("/state", state)
};

const Region = {
    load: id => requests.getAmplify("hotgiggity-be", `/region/${id}`),
    update: region => requests.putAmplify("hotgiggity-be", `/region/${region.id}`, region),
    create: region => requests.post("/region", region)
};

const SendBookingDetails = {
    getByProfileIdAndBookingId: (profileId, bookingId) => requests.getAmplify("hotgiggity-be", `/send/bookingdetail/${profileId}/${bookingId}`),
}
const Booking = {
    getInsuranceDocument: (profileId) => requests.getAmplify('hotgiggity-be', `/booking/${profileId}/insuranceFile`),
    getActBookingDetails: (actId) => requests.getAmplify('hotgiggity-be', `/profile/musician/detail/${actId}`),
    sendBookingDetailsToEmail: (data) => requests.postAmplify("hotgiggity-be", `/booking/details/sendEmail`, data),
    getPDFBookingDetails: (bookingId, sendFeeDetails, pdfOptions = null) => {
        const url = `/booking/details/pdf/${bookingId}/${sendFeeDetails}`;
        let queryStringParameters = null;
        if (pdfOptions) {
            queryStringParameters = {};
            if (pdfOptions.includeActPhone !== undefined) queryStringParameters.includeActPhone = String(pdfOptions.includeActPhone);
            if (pdfOptions.includeActEmail !== undefined) queryStringParameters.includeActEmail = String(pdfOptions.includeActEmail);
            if (pdfOptions.includeActAddress !== undefined) queryStringParameters.includeActAddress = String(pdfOptions.includeActAddress);
            if (pdfOptions.includeVenueContract !== undefined) queryStringParameters.includeVenueContract = String(pdfOptions.includeVenueContract);
            if (pdfOptions.includeAgencyContract !== undefined) queryStringParameters.includeAgencyContract = String(pdfOptions.includeAgencyContract);
        }
        return requests.getPlainAmplify("hotgiggity-be", url, queryStringParameters);
    }, 
    loadSocial: (profileId, startDate, endDate, organisationId, stateId, regionId, venueId, actId, page, creatorId) =>
    requests.getAmplify("hotgiggity-be",
        `/booking/${profileId}/socialPost?startDate=${startDate}&endDate=${endDate}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&venueId=${venueId}&actId=${actId}&limit=${50}&page=${page}&creatorId=${creatorId}`
    ),
    getAllowBooking: (organisationId, isOrganisation) => requests.getAmplify('hotgiggity-be', `/organisation/profile/allowBooking/${organisationId}/${isOrganisation}`),
    deleteBooking: (bookingId,profileId) => requests.putAmplify("hotgiggity-be", `/booking/delete/${bookingId}/${profileId}`),
    duplicateBooking: (bookingId,profileId) => requests.postAmplify("hotgiggity-be", `/booking/${bookingId}/duplicate/${profileId}`),
    sendReminder: data => requests.postAmplify('hotgiggity-be', `/booking/reminder`, data),
    sendReminderRequest: data => requests.postAmplify('hotgiggity-be', `/booking/reminder/request`, data),
    save: book => requests.postAmplify('hotgiggity-be', `/booking/booking`, book),
    saveAutoApprove: book => requests.postAmplify('hotgiggity-be', `/booking/booking-auto-approve`, book),
    initializeBook: (actId, venueId, profileId, bookingDate) => requests.getAmplify('hotgiggity-be', `/booking/booking/?act=${actId}&venue=${venueId}&currentProfile=${profileId}&bookingDate=${bookingDate}`),
    getBooking: id => requests.getAmplify("hotgiggity-be", `/booking/profile/` + id),
    getBookingRelatedAct: (id, startDate, endDate) => requests.getAmplify("hotgiggity-be", `/booking/${id}/upcoming/relatedact?startDate=${startDate}&endDate=${endDate}`),
    getBookingFilterDate: (id, startDate, endDate,utcOffset) => requests.getAmplify("hotgiggity-be", `/booking/profile/${id}/filter?startDate=${startDate}&endDate=${endDate}&utcOffset=${utcOffset}`),
    getBookingByProfileIds: profileIds =>  requests.getAmplify('hotgiggity-be', `/booking/profiles?profileIds=${profileIds}`),
    getDetail: (id, bookingRequestId, profileId) =>
        requests.getAmplify('hotgiggity-be', `/booking/detail/${id}/${bookingRequestId}/${new Date().getTimezoneOffset()}/?profileId=${profileId}`),
    getDetailCalendar: (id, bookingRequestId, profileId) =>
        requests.getAmplify('hotgiggity-be', `/booking/detail-calendar/${id}/${bookingRequestId}/?profileId=${profileId}`),
    getSummary: (id, profileId) => requests.getAmplify("hotgiggity-be", `/booking/${id}/summary?profileId=${profileId}`),
    updateStatus: (profileId, booking) => requests.postAmplify("hotgiggity-be", `/booking/${profileId}/status`, booking),

    loadRequestsGigs: (profileId, startDate, endDate, organisationId, stateId, regionId, venueId, actId, page, creatorId, bookingType, dayOfWeek) =>
        requests.getAmplify("hotgiggity-be",
            `/booking/${profileId}/requests/V3/?startDate=${startDate}&endDate=${endDate}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&venueId=${venueId}&actId=${actId}&limit=50&page=${page}&creatorId=${creatorId}&bookingType=${bookingType}&dayOfWeek=${dayOfWeek}`
        ),
    loadUpcomingGigsPublic: (profileId) => requests.getAmplify("hotgiggity-be", `/booking/${profileId}/upcomingsPublic`),
    loadUpcomingsGigs: (profileId, startDate, endDate, organisationId, stateId, regionId, venueId, actId, page, creatorId, bookingType, actAdminId, dayOfWeek) =>
        requests.getAmplify("hotgiggity-be",
            `/booking/${profileId}/upcomings/V3/?startDate=${startDate}&endDate=${endDate}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&venueId=${venueId}&actId=${actId}&limit=${30}&page=${page}&creatorId=${creatorId}&bookingType=${bookingType}&actAdminId=${actAdminId}&dayOfWeek=${dayOfWeek}`
        ),
    loadUpcomingsGigsWithoutAdhoc: (profileId, startDate, endDate, organisationId, stateId, regionId, venueId, actId) =>
        requests.getAmplify("hotgiggity-be",
            `/booking/${profileId}/upcomings/v2/?startDate=${startDate}&endDate=${endDate}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&venueId=${venueId}&actId=${actId}&excludeAdhoc=true&limit=${100}&page=${1}`
        ),
    loadEntertainmentUpcomingsGigsWithoutAdhoc: (venueId, startDate, endDate) =>
        requests.getAmplify("hotgiggity-be", `/booking/${venueId}/upcomings/entertainment?startDate=${startDate}&endDate=${endDate}&excludeAdhoc=true`),
    loadEntertainmentUpcomingsGigsWithoutAdhocIncludeGenre: (venueId, startDate, endDate) =>
        requests.getAmplify("hotgiggity-be", `/booking/${venueId}/upcomings/entertainment?startDate=${startDate}&endDate=${endDate}&excludeAdhoc=true&includeGenre=true`),
    loadUpcomingGigsNextEvent: (profileId) =>
    requests.getAmplify("hotgiggity-be", `/booking/${profileId}/upcomings/nextEvent`),
    loadUpcomingGigs4NextEvent: (profileId) =>
    requests.getAmplify("hotgiggity-be", `/booking/${profileId}/upcomings/next4Event`),
    loadEntertainmentUpcomingsGigsWithoutAdhocGigGuideEmbed: (profileId, startDate, endDate) =>
        requests.getAmplify("hotgiggity-be", `/booking/${profileId}/upcomings/entertainmentGigGuideEmbed?startDate=${startDate}&endDate=${endDate}&utcOffset=${new Date().getTimezoneOffset()}`),
    loadEntertainmentUpcomingsGigsWithoutAdhocGigGuideEmbedV2: (profileId, startDate) =>
        requests.getAmplify("hotgiggity-be", `/booking/${profileId}/upcomings/entertainmentGigGuideEmbedV2?startDate=${startDate}&utcOffset=${new Date().getTimezoneOffset()}`),
    loadCompletedGigs: (profileId, startDate, endDate, organisationId, stateId, regionId, venueId, actId, page, creatorId, bookingType, dayOfWeek) =>
        requests.getAmplify("hotgiggity-be",
            `/booking/${profileId}/completed/V3/?startDate=${startDate}&endDate=${endDate}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&venueId=${venueId}&actId=${actId}&limit=50&page=${page}&creatorId=${creatorId}&bookingType=${bookingType}&dayOfWeek=${dayOfWeek}`
        ),
    loadAllGigs: (profileId, startDate, endDate, organisationId, stateId, regionId, venueId, actId,page, creatorId, bookingType, dayOfWeek) =>
        requests.getAmplify("hotgiggity-be",
            `/booking/${profileId}/all/?startDate=${startDate}&endDate=${endDate}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&venueId=${venueId}&actId=${actId}&limit=50&page=${page}&creatorId=${creatorId}&bookingType=${bookingType}&dayOfWeek=${dayOfWeek}`
        ),
    loadCancelledGigs: (profileId, startDate, endDate, organisationId, stateId, regionId, venueId, actId, page, creatorId, bookingType, dayOfWeek) =>
        requests.getAmplify("hotgiggity-be",
            `/booking/${profileId}/cancelled/V3/?startDate=${startDate}&endDate=${endDate}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&venueId=${venueId}&actId=${actId}&limit=50&page=${page}&creatorId=${creatorId}&bookingType=${bookingType}&dayOfWeek=${dayOfWeek}`
        ),

    loadLineup: id => requests.getAmplify('hotgiggity-be', `/booking/${id}/lineup`),
    saveLineups: (booking,profileId) => requests.postAmplify('hotgiggity-be', `/booking/${booking.id}/lineup/v2/${profileId}`, booking),
    checkAvailability: booking => requests.postAmplify('hotgiggity-be', `/booking/checkAvailability`, booking),
    cancelBooking: booking => requests.postAmplify("hotgiggity-be", `/booking/cancel`, booking),
    acknowledgeGigs: (profileId, bookingId) => requests.put(`/booking/${profileId}/acknowledge/${bookingId}`),
    unacknowledgeGigs: (profileId, bookingId) => requests.put(`/booking/${profileId}/unacknowledge/${bookingId}`),
    // getCalendarBooking: (profileId, currentProfileId) => requests.getAmplify("hotgiggity-be", `/booking/${profileId}/calendar/${currentProfileId}`),
    getCalendarBooking: (profileId, currentProfileId, startDate, endDate, utcOffset) => requests.getAmplify("hotgiggity-be", `/booking/${profileId}/calendar/${currentProfileId}/filter?startDate=${startDate}&endDate=${endDate}&utcOffset=${utcOffset}`),
    setReminder: id => requests.post(`/booking/${id}/reminder`),
    requestExtraGigFee: (id, extraGigFee) => requests.get(`/booking/${id}/requestExtraGigFee/${extraGigFee}`),
    approveExtraGigFee: (id, profileId) => requests.get(`/booking/${id}/approveExtraGigFee/${profileId}`),
    declineExtraGigFee: (id, profileId) => requests.get(`/booking/${id}/declineExtraGigFee/${profileId}`),

    getBookableActs: (profileId, bookingId, bookingDate, startTime, endTime, actType, actLineupCount,utcOffset,actId) =>
        requests.getAmplify('hotgiggity-be', `/booking/${profileId}/bookable/act/v2/${bookingId}/${bookingDate}/${startTime}/${endTime}/${actType?actType:0}/${actLineupCount?actLineupCount:0}/${utcOffset}/${actId ? actId : "undefined"}`),
    getHistory: (id, profileId) => requests.getAmplify("hotgiggity-be", `/booking/${id}/history/${profileId}`),
    updateBookingsPurchaseOrder: data => requests.put(`/booking/purchaseOrder`, data),

    getClientEmailPreview: id => requests.getAmplify('hotgiggity-be', `/booking/${id}/clientEmail/preview`),
    sendClientEmail: (id, data) => requests.postAmplify('hotgiggity-be', `/booking/${id}/clientEmail/send`, data),
    getBookingCount: (profileId) => requests.getAmplify('hotgiggity-be', `/booking/count/${profileId}`),
    bulkUpdate: (data) => amplifyRequest('put', 'hotgiggity-be', `/booking/bulk-edit`, customRequest(data)).then(res => res?.response || res),
    cancelBulk: (data) => requests.postAmplify('hotgiggity-be', `/booking/cancel-bulk`, data),
    deleteBulk: (profileId, data) => requests.putAmplify('hotgiggity-be', `/booking/delete-bulk/${profileId}`, data),
};

const BookingRequest = {
    create: bookings => requests.postAmplify("hotgiggity-be", `/bookingRequest/create`, bookings),
    accept: bookingReqId => requests.postAmplify("hotgiggity-be", `/bookingRequest/${bookingReqId}/accept`),
    acceptBookingRequest: (bookingReqId, profileId) => requests.postAmplify("hotgiggity-be", `/bookingRequest/${bookingReqId}/${profileId}/accept`),
    decline: bookingReqId => requests.postAmplify("hotgiggity-be", `/bookingRequest/${bookingReqId}/decline`),
    remove: bookingReqId => requests.post(`/bookingRequest/${bookingReqId}/remove`)
};

const Venue = {
    load: data => requests.getAmplify("hotgiggity-be", "/user/me/venues"),
    // loadByRegionId: id => requests.get(`/region/${id}/venues`),
    delete: venueProfileId => requests.del(`/profile/${venueProfileId}`),
    loadBookableVenues: () => requests.getAmplify('hotgiggity-be', `/profile/bookableVenues`),
    getSummaries: ids => requests.getAmplify("hotgiggity-be", `/profile/venue/summary?ids=${ids}`),
    searchVenueAndIndependentVenue: name => requests.getAmplify('hotgiggity-be', `/venue/${name}/search`),
    getUserVenuesBasedOnPermission: (edit, manage, financial, booking, promote) =>
        requests.getAmplify('hotgiggity-be', `/profile/venue/permission?edit=${edit}&manage=${manage}&financial=${financial}&booking=${booking}&promote=${promote}`),
    getUserVenuesBasedOnPermissionSimple: (edit, manage, financial, booking, promote) =>
        requests.getAmplify('hotgiggity-be', `/profile/venue/permission/simple?edit=${edit}&manage=${manage}&financial=${financial}&booking=${booking}&promote=${promote}`)
};

const Promotion = {
    savePromotion: promotion => requests.postAmplify('hotgiggity-be', `/promotion/save`, promotion),
    uploadPromotionImage: (promotionId, images) => requests.postAmplify('hotgiggity-be', `/promotion/${promotionId}/image`, images),
    getPending: () => requests.getAmplify('hotgiggity-be', `/promotion/organisation/pending`),
    getPublished: () => requests.getAmplify('hotgiggity-be', `/promotion/organisation/published`),
    getCompleted: () => requests.getAmplify('hotgiggity-be', `/promotion/organisation/completed`),
    getById: promotionId => requests.getAmplify('hotgiggity-be', `/promotion/id/${promotionId}`),
    removePromotion: promotionId => requests.delAmplify('hotgiggity-be', `/promotion/${promotionId}/delete`)
};

const Event = {
    getByProfileId: profileId => requests.getAmplify("hotgiggity-be", `/event/profile/${profileId}`),
    getByProfileIds: profileIds => requests.getAmplify("hotgiggity-be", `/event/profiles/?profileIds=${profileIds}`),
    get: eventId => requests.getAmplify("hotgiggity-be", `/event/${eventId}`),
    create: event => requests.postAmplify("hotgiggity-be", "/event/create", event),
    update: event => requests.postAmplify("hotgiggity-be", `/event/update/${event.id}`, event),
    delete: eventId => requests.delAmplify("hotgiggity-be", `/event/delete/${eventId}`)
};

const NegotiateMessage = {
    deleteNegotiateMessage : id => requests.put(`/booking/messages/delete/${id}`),
    loadByBookingId: id => requests.getAmplify("hotgiggity-be", `/booking/${id}/messages`),
    update: negotiateMessage => requests.post(`/negotiateMessage/${negotiateMessage.id}`, negotiateMessage),
    create: negotiateMessage => requests.postAmplify("hotgiggity-be", "/negotiateMessage", negotiateMessage)
};

const Lineup = {
    get: id => requests.get(`/lineup/${id}`),
    updateStatus: lineup => requests.postAmplify('hotgiggity-be', `/lineup/${lineup.id}/status`, lineup),
    setReminder: lineup => requests.post(`/lineup/${lineup.id}/reminder`, lineup)
};

const SocialPost = {
    get: (bookingId, profileId) => requests.getAmplify('hotgiggity-be', `/social/${bookingId}/post/${profileId}`),
    create: data => requests.postAmplify('hotgiggity-be', `/social/post`, data),
    postToFacebook: (id) => requests.postAmplify('hotgiggity-be', `/social/postToFacebook/${id}`),
    cancel: (id) => requests.postAmplify('hotgiggity-be', `/social/post/cancel/${id}`),
    postToInstagram: (id) => requests.postAmplify('hotgiggity-be', `/social/postToInstagram/${id}`),
    postImage: data => requests.postAmplify('hotgiggity-be', `/social/postImage`, data)
}

const GeneralSocialPost = {
    getByProfileId: (profileId,startDate, endDate,venueId,page) => requests.getAmplify('hotgiggity-be', `/social/originalPost/creator/${profileId}?startDate=${startDate}&endDate=${endDate}&venueId=${venueId}&limit=${10}&page=${page}`),
    get: (id) => requests.getAmplify('hotgiggity-be', `/social/originalPost/${id}`),
    create: data => requests.postAmplify('hotgiggity-be', `/social/originalPost`, data),
    postToFacebook: (id) => requests.postAmplify('hotgiggity-be', `/general/social/postToFacebook/${id}`),
    cancel: (id) => requests.postAmplify('hotgiggity-be', `/social/originalPost/cancel/${id}`),
    postToInstagram: (id) => requests.postAmplify('hotgiggity-be', `/general/social/postToInstagram/${id}`),
    postImage: data => requests.postAmplify('hotgiggity-be', `/social/original/postImage`, data)
}

// const Facebook = {
//     login: token => requests.get(`/auth/facebook/callback/${token}`),
//     setPage: data => requests.post(`/profile/facebook`, data),
//     disconnectPage: data => requests.put(`/profile/facebook`, data),
//     getPages: (id, token) => requests.get(`/profile/facebook/${id}/pages/${token}`),
//     postToFacebook: (id, booking) => requests.post(`/booking/${id}/facebook`, booking),
//     playerPostToFacebook: (id, booking) => requests.post(`/booking/player/${id}/facebook`, booking)
// };



const Facebook = {
    login: token => requests.get(`/auth/facebook/callback/${token}`),
    setPage: data => requests.postAmplify("hotgiggity-be", `/profile-facebook`, data),
    refreshPage: data => requests.postAmplify("hotgiggity-be", `/profile-instagram-refresh`, data),
    setInstagramPage: data => requests.postAmplify("hotgiggity-be", `/profile-facebook-instagram`, data),
    disconnectPage: data => requests.putAmplify("hotgiggity-be", `/profile-facebook`, data),
    getPages: (id, token) => requests.getAmplify("hotgiggity-be", `/profile-facebook/${id}/pages/${token}`),
    postToFacebook: (id, booking) => requests.postAmplify("hotgiggity-be", `/booking/${id}/facebook`, booking),
    playerPostToFacebook: (id, booking) => requests.postAmplify("hotgiggity-be", `/booking/player/${id}/facebook`, booking)
}

const LineupMessage = {
    getBookingLineupMessage: bookingId => requests.getAmplify('hotgiggity-be', `/lineupMessage/${bookingId}/messages`),
    postBookingLineupMessage: messages => requests.postAmplify('hotgiggity-be', `/lineupMessage/create`, messages),
    deleteLineupMessage: id => requests.putAmplify('hotgiggity-be', `/lineupMessage/${id}/delete`)
};

const Conversation = {
    create: message => requests.postAmplify("hotgiggity-be", `/conversation/new/message`, message),
    createContactActConversation: message => requests.publicPostAmplify("hotgiggity-be", `/conversation/publicnew`, message),
    createMessage: message => requests.postAmplify("hotgiggity-be", `/conversation/message`, message),
    loadByProfileId: profileId => requests.getAmplify("hotgiggity-be", `/profile/${profileId}/conversation`, profileId),
    loadById: id => requests.getAmplify("hotgiggity-be", `/conversation/${id}`, id),
    addParticipant: (participantId, participantData) => requests.postAmplify("hotgiggity-be", `/conversationParticipant/addParticipant/by/${participantId}`, participantData),
    deleteMessage: (messageId) => requests.putAmplify("hotgiggity-be", `/message/delete/${messageId}`),
    removeParticipant: (participantRemove, conversationId, participantCreate) => requests.putAmplify("hotgiggity-be", `/conversationParticipant/remove/${participantRemove}/from/${conversationId}/by/${participantCreate}`),
    leaveConversation: (conversationId, participantId) => requests.putAmplify("hotgiggity-be", `/conversation/${conversationId}/leaveConversation/${participantId}`),
    updateConversationRead: (profileId, conversationId) => requests.putAmplify("hotgiggity-be", `/message/${profileId}/conversation/${conversationId}`),
    updateSubjectConversation: (conversationId, newSubject, participantId) => requests.putAmplify("hotgiggity-be", `/conversation/${conversationId}/changeSubject/${newSubject}/by/${participantId}`),
    updateMessage: (messageId, message) => requests.putAmplify("hotgiggity-be", `/message/${messageId}`, message),
};

const Invoice = {  
    readyToPayCheck: (id, data) => requests.postAmplify("hotgiggity-be", `/invoice/readyToPayCheck/${id}`,data),
    getBookingCreatorByInvoiceId: id => requests.getAmplify("hotgiggity-be", `/invoice/${id}/getBookingOwner`),
    get: id => requests.getAmplify("hotgiggity-be", `/invoice/${id}/detail`),
    getProfileId: (id, profileId) => requests.getAmplify("hotgiggity-be", `/invoice/${id}/detail/${profileId}`),
    getPdf: id => requests.getAmplify("hotgiggity-be", `/invoice/${id}/pdf`),
    getAll: () => requests.getAmplify("hotgiggity-be", `/invoice`),
    getByPayeeId: payeeId => requests.getAmplify("hotgiggity-be", `/invoice/payee/${payeeId}`),
    getByPayeeIds: payeeIds => requests.getAmplify("hotgiggity-be", `/invoice/payees?payeeIds=${payeeIds}`),
    getByPayerId: payerId => requests.getAmplify("hotgiggity-be", `/invoice/payer/${payerId}`),
    getByPayerIds: payerIds => requests.getAmplify("hotgiggity-be", `/invoice/payers?payerIds=${payerIds}`),
    getInvoiceByBookingAndProfileId: (bookingId,profileId) => requests.getAmplify("hotgiggity-be", `/invoice/booking/${bookingId}/profile/${profileId}`), 
    getByPayeeIdAndFilter: (payeeId, startDate, endDate, organisationId, stateId, regionId, venueId, statusFilter, actId, page, limit, contactId, bookingType, search) =>
        requests.getAmplify("hotgiggity-be", `/invoice/payee/${payeeId}/filter/v3?page=${page}&limit=${limit? limit: 40}&startDate=${startDate}&endDate=${endDate}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&venueId=${venueId}&status=${statusFilter}&actId=${actId}&contactId=${contactId}&bookingType=${bookingType}${search ? `&search=${encodeURIComponent(search)}` : ''}`),

    getByPayerIdAndFilter: (payerId, startDate, endDate, organisationId, stateId, regionId, venueId, statusFilter, actId, page, limit, contactId, bookingType, search) =>
        requests.getAmplify("hotgiggity-be", `/invoice/payer/${payerId}/filter/v3/?limit=${limit? limit : 40}&page=${page}&startDate=${startDate}&endDate=${endDate}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&venueId=${venueId}&status=${statusFilter}&actId=${actId}&contactId=${contactId}&bookingType=${bookingType}${search ? `&search=${encodeURIComponent(search)}` : ''}`),


    generate: payeeId => requests.getAmplify("hotgiggity-be", `/invoice/generate/${payeeId}`),
    syncQuickBooks: (invoiceId, data) => requests.post(`/invoice/${invoiceId}/quickbooks`, data),
    createQuickBooksCustomer: (profileId, invoiceId, data) =>
        requests.post(`/profile/${profileId}/quickbooks/customers?invoiceId=${invoiceId}`, data),
    downloadPdf: id => requests.getPlainAmplify("hotgiggity-be", `/invoice/${id}/download/pdf`),
    payInvoice: (invoiceId, data) => requests.postAmplify('hotgiggity-be', `/invoice/pay/${invoiceId}`, data),
    updatePaidDate: (invoiceId, data) => requests.postAmplify('hotgiggity-be', `/invoice/updatePaidDate/${invoiceId}`, data),
    unPayInvoice: (invoiceId, data) => requests.postAmplify('hotgiggity-be', `/invoice/unpay/${invoiceId}`, data),
    markOutstanding: invoiceId => requests.postAmplify('hotgiggity-be', `/invoice/${invoiceId}/markOutstanding`),
    declineInvoice: invoiceId => requests.get(`/invoice/decline/${invoiceId}`),
    generateReport: (profileType, startDate, endDate, organisationId, stateId, regionId, venueId, statusFilter) =>
        requests.get(
            `/invoice/reports?profileType=${profileType}&startDate=${startDate}&endDate=${endDate}&organisationId=${organisationId}&stateId=${stateId}&regionId=${regionId}&venueId=${venueId}&status=${statusFilter}`
        ),
    downloadBatchPdf: ids => requests.getPlainAmplify("hotgiggity-be", `/invoice/download/batch/pdf?invoiceIds=${ids}`),
    updateInvoicesPurchaseOrder: data => requests.putAmplify("hotgiggity-be", `/invoice/purchaseOrder`,data),
    getBookingByInvoiceId: invoiceId => requests.getAmplify("hotgiggity-be", `/invoice/${invoiceId}/booking`),
    unsyncSendToAccount: invoiceId => requests.postAmplify("hotgiggity-be", `/invoice/${invoiceId}/unsyncSendtoaccount`),
    getByIdSimple: invoiceId => requests.getAmplify("hotgiggity-be", `/invoice/${invoiceId}/detail/simple`), 
};

const Signature = {
    load: id => requests.get(`/signature/${id}`),
    loadByProfileId: id => requests.getAmplify("hotgiggity-be", `/profile/staff/signature/${id}`),
    loadByBookingId: (bookingId, profileId) => requests.getAmplify("hotgiggity-be", `/booking/${bookingId}/signature/${profileId}}`),
    create: (profileId, signature) => requests.postAmplify("hotgiggity-be", `/signature`, signature),
    update: signature => requests.postAmplify("hotgiggity-be", `/signature/${signature.id}`, signature),
    delete: id => requests.del(`/signature/${id}`),
    updateSignatureProfile: (profileId, signature) => requests.postAmplify("hotgiggity-be", `/signatureProfile/${profileId}`, signature),
};

const UserInvitation = {
    create: invitation => requests.postAmplify("hotgiggity-be", `/userInvitation/create`, invitation),
    getByInvitationToken: token => requests.get(`/userInvitation/${token}/token`),
    getMyInvitation: (profileId, type) => requests.getAmplify("hotgiggity-be", `/userInvitation/${profileId}/invitation/${type}`),
    delete: invitation => requests.postAmplify("hotgiggity-be", `/userInvitation/delete`, invitation),
    deleteMany: invitations => requests.postAmplify("hotgiggity-be", `/userInvitation/deleteMany`, invitations),
    getUserInvitationByUserEmailAndType: (userEmail, type) => requests.getAmplify("hotgiggity-be", `/userInvitation/${userEmail}/byEmail/${type}`),
    getByAgentIdPlaceId: (agentId, placeId ) => requests.getAmplify("hotgiggity-be", `/venue/${agentId}/external/${placeId}`),
    accept: invitationId => requests.putAmplify("hotgiggity-be", `/userInvitation/${invitationId}/accept`),
    decline: invitationId => requests.putAmplify("hotgiggity-be", `/userInvitation/${invitationId}/decline`),
    resendLink: (invitationId,profileId) => requests.postAmplify("hotgiggity-be", `/resend/${profileId}/invitation/${invitationId}`),
    
}

const hgBilling = {
    getProfileAccess: (profileId) =>  requests.getAmplify("hotgiggity-be", `/hgBilling/getProfileStatus/${profileId}`),
    cancelSubscription: (type) => requests.postAmplify("hotgiggity-be", `/hgBilling/subscription/cancel/${type}`),
    getCustomerAccess: (type) => requests.getAmplify("hotgiggity-be", `/hgBilling/getCustomer/${type}`),
    postCheckout: (data, profileId) => requests.postAmplify("hotgiggity-be", `/hgBilling/checkout/${profileId}`, data),
    updateSubscriptionPostCheckout : (data) => requests.postAmplify("hotgiggity-be", `/hgBilling/updateSubscription`, data),
    addPaymentMethod: () => requests.postAmplify("hotgiggity-be", `/hgBilling/creditCard`),
    getPaymentMethod: () => requests.getAmplify("hotgiggity-be", `/hgBilling/creditCard`),
    deletePaymentMethod: (data) => requests.postAmplify("hotgiggity-be", `/hgBilling/creditCard/delete`,data),
    setAsDefaultPaymentMethod: (data) => requests.postAmplify("hotgiggity-be", `/hgBilling/paymentMethod/setdefault`,data),
}
const Billing = {
    upgradeProPlan: (profileType, data) => requests.postAmplify("hotgiggity-be", `/billing/customers/${profileType}/upgradeSubscription`, data),
    downgradeProPlan: (profileType, data) => requests.postAmplify("hotgiggity-be", `/billing/customers/${profileType}/downgradeSubscription`, data),
    cancelDowngradeProPlan: (profileType) => requests.postAmplify("hotgiggity-be", `/billing/customers/${profileType}/cancelDowngrade`),
    getProducts: () => requests.get(`/billing/products/`),
    getBillingPlans: () => requests.get(`/billing/plans/`),
    getCustomer: customerId => requests.get(`/billing/customers/${customerId}`),
    getCustomerByUserId: userId => requests.get(`/billing/customers/users/${userId}`),
    createCustomer: customer => requests.postAmplify("hotgiggity-be", `/billing/customers`, customer),
    addCard: (customerId, card) => requests.post(`/billing/customers/${customerId}/cards/`, {customerId, card}),
    removeCard: (customerId,profileType) =>  requests.postAmplify("hotgiggity-be", `/billing/customers/${customerId}/cards/remove`, {customerId,profileType}),
    getCardByCustomerId: customerId => requests.get(`/billing/customers/${customerId}/cards/`),
    createSubscription: (customerId, planId) => requests.get(`/billing/customers/${customerId}/subscription/${planId}`),
    getSubscriptionByCustomerId: customerId => requests.get(`/billing/customers/${customerId}/subscription/`),
    getChargesByCustomerId: customerId => requests.get(`/billing/customers/${customerId}/charges/`),
    getInvoicesByCustomerId: customerId => requests.get(`/billing/customers/${customerId}/invoices/`),
    downloadPdf: (customerId, invoiceId) => requests.getFile(`/billing/customers/${customerId}/invoices/${invoiceId}/pdf`),
    getBillingInformation: customerId => requests.get(`/billing/customers/${customerId}/billinginfo/`),
    updateSubscriptionInEndPeriodByCustomerId: (customerId, data) => requests.patch(`/billing/customers/${customerId}/subscriptions/`, data),
    cancelMembershipBySubscriptionId: (subscriptionId) => requests.post(`/billing/subscriptions/${subscriptionId}/cancel`, null),
    getPaymentAccesses: userId => requests.getAmplify("hotgiggity-be", `/billing/customers/users/${userId}/paymentAccesses/`),
    updateCustomerEmail: (data) =>  requests.postAmplify("hotgiggity-be", `/billing/update/email`, data),
    billingAccess: (sub, type) => requests.get(`/billing/customers/users/${sub}/access/${type}`),
    subscribeSingleVenueProPlan: (profileId) => requests.postAmplify("hotgiggity-be", `/billing/customers/upgrade/singleVenuePro`, {profileId: profileId})
};

const ProfileViews = {
    insertProfileViews: profileId => requests.postAmplify("hotgiggity-be", `/profileviews/insert/${profileId}`),
}

const GoogleCalendar = {
    // exchangeTokenAndGetGoogleCalendarList : 
    exchangeTokenAndGetGoogleCalendarList: data => requests.postAmplify("hotgiggity-be", `/googlecalendar/token`, data),
    selectCalendar: data => requests.postAmplify("hotgiggity-be", '/googlecalendar/selectcalendar', data),
    disconnectGoogle: data => requests.postAmplify("hotgiggity-be", '/googlecalendar/disconnect', data),
    getProfileGoogleCalendar: (profileId, startDate, endDate,utcOffset) => requests.getAmplify("hotgiggity-be", `/googlecalendar/getListEvent?profileId=${profileId}&startDate=${startDate}&endDate=${endDate}&utcOfset=${utcOffset}`)
} 

const InstagramIntegration = {
    // exchangeTokenAndGetGoogleCalendarList : 
    exchangeToken: data => requests.postAmplify("hotgiggity-be", `/instagram/integration/token`, data),
    disconnectInstagram: data => requests.postAmplify("hotgiggity-be", '/instagram/integration/disconnect', data),

}   
const GigPromotion = {
    saveGigPromotion: gigPromotion => requests.postAmplify("hotgiggity-be", `/promotion/gig/save`, gigPromotion),
    getGigPromotionImage: id => requests.get(`/promotion/gig/image/${id}`),
    uploadGigPromotionImage: (gigPromotionId, images) => requests.postAmplify("hotgiggity-be", `/promotion/gig/${gigPromotionId}/image`, images),
    uploadGigPromotionActImage: (gigPromotionId, images) => requests.postAmplify("hotgiggity-be", `/promotion/gig/${gigPromotionId}/act/image`, images),
    deleteGigPromotionImage: id => requests.delAmplify("hotgiggity-be", `/promotion/gig/image/${id}`),
    getPending: () => requests.getAmplify("hotgiggity-be", `/promotion/gig/pending`),
    getPublished: () => requests.getAmplify("hotgiggity-be", `/promotion/gig/published`),
    getCompleted: () => requests.getAmplify("hotgiggity-be", `/promotion/gig/completed`),
    getPendingFiltered: (dateFrom, dateTo, venueIds, page, take, search) => {
        let url = `/promotion/gig/pending?page=${page}&take=${take}`;
        if (dateFrom) url += `&dateFrom=${dateFrom}`;
        if (dateTo) url += `&dateTo=${dateTo}`;
        if (venueIds && venueIds.length > 0) venueIds.forEach(id => { url += `&venueIds[]=${id}`; });
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return requests.getAmplify("hotgiggity-be", url);
    },
    getPublishedFiltered: (dateFrom, dateTo, venueIds, page, take, search) => {
        let url = `/promotion/gig/published?page=${page}&take=${take}`;
        if (dateFrom) url += `&dateFrom=${dateFrom}`;
        if (dateTo) url += `&dateTo=${dateTo}`;
        if (venueIds && venueIds.length > 0) venueIds.forEach(id => { url += `&venueIds[]=${id}`; });
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return requests.getAmplify("hotgiggity-be", url);
    },
    getCompletedFiltered: (dateFrom, dateTo, venueIds, page, take, search) => {
        let url = `/promotion/gig/completed?page=${page}&take=${take}`;
        if (dateFrom) url += `&dateFrom=${dateFrom}`;
        if (dateTo) url += `&dateTo=${dateTo}`;
        if (venueIds && venueIds.length > 0) venueIds.forEach(id => { url += `&venueIds[]=${id}`; });
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return requests.getAmplify("hotgiggity-be", url);
    },
    getById: gigPromotionId => requests.getAmplify('hotgiggity-be', `/promotion/gig/id/${gigPromotionId}`),
    removeGigPromotion: gigPromotionId => requests.delAmplify("hotgiggity-be", `/promotion/${gigPromotionId}/gig/delete`),
    getOztixVenues: params => {
        const qs = [];
        if (params && params.state) qs.push(`state=${encodeURIComponent(params.state)}`);
        if (params && params.locality) qs.push(`locality=${encodeURIComponent(params.locality)}`);
        if (params && params.name) qs.push(`name=${encodeURIComponent(params.name)}`);
        const query = qs.length > 0 ? `?${qs.join("&")}` : "";
        return requests.getPlainAmplify("hotgiggity-be", `/oztix/venues${query}`);
    },
    getOztixEvents: params => {
        const qs = [];
        if (params.eventId)   qs.push(`eventId=${encodeURIComponent(params.eventId)}`);
        if (params.state)     qs.push(`state=${encodeURIComponent(params.state)}`);
        if (params.locality)  qs.push(`locality=${encodeURIComponent(params.locality)}`);
        if (params.eventName) qs.push(`eventName=${encodeURIComponent(params.eventName)}`);
        if (params.venueIds)  params.venueIds.forEach(id => qs.push(`venueIds[]=${encodeURIComponent(id)}`));
        if (params.dateFrom)  qs.push(`dateFrom=${encodeURIComponent(params.dateFrom)}`);
        if (params.dateTo)    qs.push(`dateTo=${encodeURIComponent(params.dateTo)}`);
        return requests.getPlainAmplify("hotgiggity-be", `/oztix/events?${qs.join("&")}`);
    },
    syncFromOztix: data => requests.postAmplify("hotgiggity-be", `/oztix/sync`, data),
    getOrganisationEmbedGigs: (organisationId, params) => {
        const qs = [];
        if (params && params.startDate) qs.push(`startDate=${encodeURIComponent(params.startDate)}`);
        if (params && params.endDate)   qs.push(`endDate=${encodeURIComponent(params.endDate)}`);
        if (params && params.utcOffset != null) qs.push(`utcOffset=${encodeURIComponent(params.utcOffset)}`);
        if (params && params.venueIds)  params.venueIds.forEach(id => qs.push(`venueIds[]=${encodeURIComponent(id)}`));
        if (params && params.venueId)   qs.push(`venueIds[]=${encodeURIComponent(params.venueId)}`);
        if (params && params.page)      qs.push(`page=${encodeURIComponent(params.page)}`);
        if (params && params.take)      qs.push(`take=${encodeURIComponent(params.take)}`);
        if (params && params.isTicketing) qs.push(`isTicketing=true`);
        if (params && params.isTicketing==false) qs.push(`isTicketing=false`);
        if (params && params.dayOfWeek) qs.push(`dayOfWeek=${encodeURIComponent(params.dayOfWeek)}`);
        const query = qs.length > 0 ? `?${qs.join("&")}` : "";
        console.log(query)
        return requests.getAmplify("hotgiggity-be", `/gigPromotion/${organisationId}/organisation/embed${query}`);
    }
};

const UserFestivals = {
    getUserFestivalForAct: actId => requests.getAmplify("hotgiggity-be", `/festival/act/${actId}`),
    registerActToFestivals: (actId, festivalId, venueId) => requests.post(`/festival/${festivalId}/register/${actId}/at/${venueId}`),
    registerToAgentFestival: (actId, agentId, venueId) => requests.post(`/festival/agent/${agentId}/register/${actId}/at/${venueId}`)
};

const VenueExternalInvitation = {
    create: (data) => requests.postAmplify("hotgiggity-be", `/venue/external/invite`, data),
    
}

const ReferralProfile = {
    create: (referralCode, userId) => requests.postAmplify("hotgiggity-be", `/profileReferralMapping/${referralCode}/${userId}`),
    
}

const ApplyToPlayCustomRegisterUser = {
    create: (userId, referralAgentId) => 
        requests.postAmplify("hotgiggity-be", "/apply-to-play-custom-register", { 
            userId, 
            referralAgentId 
        }),
    
    getByUserId: (userId) => {
        return amplifyRequest('get', 'hotgiggity-be', `/apply-to-play-custom-register/${userId}`, customRequest())
            .then(res => {
                console.log("📡 Raw Response dari Amplify:", res);

                let rawData = res;
                if (res && res.data !== undefined) rawData = res.data;

                // Handle BE return string (res.send)
                if (typeof rawData === 'string' && rawData.length > 0) {
                    try {
                        return JSON.parse(rawData);
                    } catch (e) {
                        return rawData;
                    }
                }

                return rawData;
            })
            .catch(err => {
                console.error("❌ Error fetching referral data:", err);
                return null;
            });
    }, 
    
    delete: (userId) =>
        requests.delAmplify("hotgiggity-be", `/apply-to-play-custom-register/${userId}`)
};

const BookingAttachments = {
    getUploadUrl: (bookingId, data) => requests.postAmplify("hotgiggity-be", `/bookings/${bookingId}/attachments/upload-url`, data),
    confirmUpload: (bookingId, profileId, data) => requests.postAmplify("hotgiggity-be", `/bookings/${bookingId}/attachments?profileId=${profileId}`, data),
    list: (bookingId, profileId) => requests.getAmplify("hotgiggity-be", `/bookings/${bookingId}/attachments?profileId=${profileId}`),
    updateTitle: (bookingId, attachmentId, data) => requests.patchAmplify("hotgiggity-be", `/bookings/${bookingId}/attachments/${attachmentId}`, data),
    delete: (bookingId, attachmentId) => requests.delAmplify("hotgiggity-be", `/bookings/${bookingId}/attachments/${attachmentId}`),
};

const GalleryImages = {
    confirmUpload: (profileId, data) => requests.postAmplify("hotgiggity-be", `/profiles/${profileId}/gallery`, data),
    list: (profileId) => requests.getAmplify("hotgiggity-be", `/profiles/${profileId}/gallery`),
    updateTitle: (profileId, imageId, data) => requests.patchAmplify("hotgiggity-be", `/profiles/${profileId}/gallery/${imageId}`, data),
    delete: (profileId, imageId) => requests.delAmplify("hotgiggity-be", `/profiles/${profileId}/gallery/${imageId}`),
};

export default {
    Articles,
    Auth,
    Comments,
    Profile,
    Tags,
    MusicianGeneralProfile,
    MusicianDesignProfile,
    MusicianSocialProfile,
    MusicianFinancialProfile,
    MusicianInsuranceProfile,
    Document,
    MusicianPrivacyProfile,
    MusicianEmbedProfile,
    AgentGeneralProfile,
    AgentDesignProfile,
    AgentSocialProfile,
    AgentInsuranceProfile,
    AgentFinancialProfile,
    AgentPrivacyProfile,
    StaffGeneralProfile,
    PrivateHireGeneralProfile,
    StaffDesignProfile,
    StaffSocialProfile,
    StaffFinancialProfile,
    StaffPrivacyProfile,
    VenueGeneralProfile,
    VenueDesignProfile,
    VenueSocialProfile,
    VenueFinancialProfile,
    VenueMemberProfile,
    VenuePrivacyProfile,
    VenueMenuProfile,
    ProductionGeneralProfile,
    ProductionDesignProfile,
    ProductionSocialProfile,
    ProductionFinancialProfile,
    ProductionPrivacyProfile,
    ProductionEmbedProfile,
    DjGeneralProfile,
    DjDesignProfile,
    DjSocialProfile,
    DjFinancialProfile,
    DjPrivacyProfile,
    DjEmbedProfile,
    ActDuplicateProfile,
    ActGeneralProfile,
    ActDesignProfile,
    ActSocialProfile,
    ActFinancialProfile,
    ActPrivacyProfile,
    Roster,
    Image,
    Instrument,
    Production,
    Genre,
    ActType,
    GigType,
    ActRoster,
    SoundCloud,
    Song,
    PlayedAt,
    PlayedWith,
    Notification,
    NotificationSetting,
    ProfileRelationship,
    Organisation,
    SetList,
    OrganisationMember,
    State,
    Region,
    Venue,
    Booking,
    BookingAttachments,
    GalleryImages,
    AgentVenues,
    Event,
    AgentMusician,
    AgentAct,
    NegotiateMessage,
    VenueAct,
    Lineup,
    BookingRequest,
    AgentConsultant,
    Facebook,
    LineupMessage,
    Invoice,
    EmbedGig,
    UserInvitation,
    Billing,
    VenueType,
    Signature,
    Promotion,
    GigPromotion,
    UserFestivals,
    Conversation,
    Vibe,
    PrivateHireDesignProfile,
    PrivateHirePrivacyProfile,
    UserFavourite,
    MYOB,
    GoogleCalendar,
    ProfileViews,
    Xero,
    XeroLogs,
    SocialPost,
    InstagramIntegration,
    GooglePlace,
    VenueExternalInvitation,
    GeneralSocialPost,
    hgBilling,
    ReferralProfile,
    SendBookingDetails,
    AgentVenueContact,
    SuperAnnuationFee,
    SuperLedgers,
    SuperLedgerPayments,
    SuperAnnuationProvider,
    XeroCalendar,
    XeroEmployee,
    Admin,
    HgSuperPay,
    HgSuperPayAddon,
    ApplyToPlayCustomRegisterUser
};
